import * as ProdutoApi from "app/api/classes/ProdutoApi";
import { PagedMessageResponse } from "app/api/types/PagedMessageResponse";
import { MenuConsultaProdutosController } from "app/controllers/orcamento/menuConsultaProdutosController";
import { IProduto } from "app/types/produto/IProduto";
import { obterPermissao } from "app/use-cases/obterPermissao";
import { adicionarItens } from "app/use-cases/orcamento/adicionarItens";
import { Dict } from "app/utils/Dict";
import { forEachSeries } from "p-iteration";
import * as R from "ramda";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { substituirItemEmArray } from "substituirItemEmArray";
import globalMU from "../../../globalMU";
import microuniversoApi from "../../api/microuniversoApi";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { abrirModalCestaProdutosAction, atualizarAcaoProdutoRepetidoSelecionadoAction, atualizarQuantidadeProdutoSelecionadoAction, fecharModalCestaProdutosAction, limparProdutosSelecionadosAction, removerProdutoSelecionadoAction, removerTodasDuplicatasProdutoSelecionadoAction, selecionarProdutosAction } from "../../redux/produtosSelecionadosSlice";
import { IColuna } from "../../types/IColuna";
import { IOrcamento } from "../../types/IOrcamento";
import { Parametro } from "../../types/Parametro";
import { adicionarProdutos, produtoPodeSerAdicionadoAutomaticamenteAoOrcamento, tratamentoErroPadrao } from "../../use-cases";
import { obterParametros } from "../../use-cases/parametro/obterParametros";
import { Breadcrumb2Container } from "../breadcrumb2/Breadcrumb2Container";
import { CompararProdutosContainer } from "../comparar-produtos/CompararProdutosContainer";
import { useMenuConsultaProduto } from "../menu-consulta-produtos/useMenuConsultaProduto";
import { removerComponenteReact, renderizarComponentReact } from "../renderizarOuRemoverComponentReact";
import { DetalhesProdutoContainer } from "./detalhes-produto/DetalhesProdutoContainer";
import { ProdutoRepetido } from "./grid-itens/TBody/ItemPesquisaProduto";
import { Disponibilidade, MaisFiltrosDados } from "./mais-filtros/MaisFiltros";
import { PaginaPesquisaProduto, PaginaPesquisaProdutoContext, PaginaPesquisaProdutoContextType } from "./pagina-pesquisa-produto/PaginaPesquisaProduto";
import { PesquisaClasseContainer } from "./pesquisa-classe/PesquisaClasseContainer";
import { PesquisaCorTintometricoContainer } from "./pesquisa-cor-tintometrico/PesquisaCorTintometricoContainer";
import { PesquisaCorContainer } from "./pesquisa-cor/PesquisaCorContainer";
import { PesquisaFornecedorContainer } from "./pesquisa-fornecedor/PesquisaFornecedorContainer";
import { PesquisaPreVendaContainer } from "./pesquisa-pre-vendas/PesquisaPreVendaContainer";
import { PreVenda } from "./pesquisa-pre-vendas/PesquisaPreVendas";
import { DadosPesquisaProduto } from "./pesquisa-produto/PesquisaProdutos";
import { PesquisasAnterioresContainer } from "./pesquisas-anteriores/PesquisasAnterioresContainer";
import { ProdutosForaEstoqueContainer } from "./produtos-fora-estoque/ProdutosForaEstoqueContainer";
import store from "app/redux/store/store";
import { TratamentoMadeiraContainer } from "../madeira/TratamentoMadeiraContainer";
import { ItensOrcamentoContainer } from "../itens-orcamento/ItensOrcamentoContainer";
import { useRecuperarCestaProdutosAnterior } from "../itens-orcamento/useRecuperarCestaProdutosAnterior";
import { useRecuperarOrcamentoEmAndamento } from "../itens-orcamento/useRecuperarOrcamentoEmAndamento";
import { ProdutoFiltrado } from "app/types/IProduto";

const Backbone = require('backbone')
declare var window: any

// 491123 — ao adicionar um produto na cesta com quantidade zerada, usa a Venda Mínima do produto
// como quantidade. Sem Venda Mínima definida (ou <= 0), usa 1 — nunca deixa o produto entrar na
// cesta com quantidade 0.
const ajustarQuantidadeMinimaAoAdicionar = (produto: IProduto): IProduto => {
  if ((produto.Quantidade ?? 0) > 0) return produto

  //const quantidadeMinimaVenda = Number(globalMU.corrigirPontosEVirgulasValorDecimal(produto.QuantidadeMinimaVenda ?? "0"))
  const quantidadeMinimaVenda = produto.MenorFracaoVenda ?? 0
  return { ...produto, Quantidade: quantidadeMinimaVenda > 0 ? quantidadeMinimaVenda : 1 }
}

export type PesquisaProdutoPagina = {
  Codigo?: string;
  Referencia?: string;
  ClasseProduto?: string;
  Descricao?: string;
  Classe?: string;
  Fornecedor?: string;
  EstoqueDisponivelFilialCorrente?: boolean;
  //EstoqueDisponivelFilial?: boolean;
  EstoqueDisponivelOutrasFiliais?: boolean;
  EstoqueDisponivelCD?: boolean; // 435588
  ConsiderarEstoqueDisponivelLote?: boolean; // 435588
  TipoFiltroEstoque?: string //435588
  QuantidadeInicialFiltroEstoque?: number //435588
  QuantidadeFinalFiltroEstoque?: number //435588
  Ordem?: string;
  CodigoFabricante?: string;
  SistemaTintometrico?: number | string;
  TextoTecnico?: string;
  ModeloProduto?: string;
  MarkupFinal?: string;
  MarkupInicial?: string,
  NomeFornecedor?: string;
  ProdutoOferta?: boolean;
  ApenasFabricacaoPropria?: boolean // 440721
  TamanhoPagina?: number;
  NumeroPagina?: number;
  ProdutoEmTransito?: boolean;
  Disponibilidade?: string[];
  ProdutoFinal?: string;
  identificadorOrcamento?: string
  Codigos?: string[]
  CodigoProdutoComAgregadoSugerido?: string
  CodigoProdutoComAgregado?: string
};

// 491123 — id do host INVISÍVEL onde o botão flutuante da cesta monta esta página só para abrir o
// modal da cesta sem trocar a tela atual (ver montarPaginaPesquisaProdutosOculta em
// Views\Shared\_BaseInterno.cshtml). Só essa instância roda escondida em segundo plano; todas as
// outras regiões (conteudo-pagina, pesquisa-produtos-region, ...) são visíveis para o usuário.
export const REGIAO_HOST_OCULTO_CESTA_PRODUTOS = "BaseInterno_HostOcultoCestaProdutos"

export type PaginaPesquisaProdutoContainerProps = {
  onVoltar?: () => void,
  passos?: Dict<string, () => void>
  regiaoRenderizada?: string

  chamadoParaInserirProdutoNoOrcamento: boolean // 491123
  foraOrcamento?: boolean
  chamadoPeloTrocarProduto?: boolean // 7470882
  pesquisandoApenasParaFiltroProdutosLupa?: boolean // 470698
  ocultarBarraPesquisa?: boolean
  esconderForaEstoque?: boolean
  adicionarProdutos?: (produtosSelecionados: IProduto[]) => void
  desabilitarPesquisarHistorico?: boolean
  desabilitarInserirContinuar?: boolean

  filtroPesquisaAnterior?: string;
  dadosGridPesquisaItens?: PagedMessageResponse<IProduto>
  preVendaSelecionada?: PreVenda[]
  filtroAnterior?: PesquisaProdutoPagina
  adicionarProdutosCallBack?: any
  itensSelecionados?: IProduto[]
  ocultarSubPaginas?: boolean // 440721
};

export type ProdutosSelecionadosContextType = {
  desativarBotaoSelecionar: boolean
  desativarBotaoAplicarItens: boolean
  quantidadeItensSelecionados: number
  onSelecionar: () => void
  onAplicarItens: () => Promise<boolean>
  produtosSelecionados: IProduto[]
  onRemoverProduto: (produto: IProduto) => void
  onRemoverTodasDuplicatasProduto: (produto: IProduto) => void
  onAlterarQuantidade: (produto: IProduto, quantidade: number) => void
  onAlterarAcaoProdutoRepetido: (produto: IProduto, acao: number) => void
  onMostrarInformacoesProduto: (produto: IProduto) => void
  onAdicionarProdutoSelecionado: (produto: IProduto) => void
  onInserirProdutoDuplicadoSelecionado: (produto: IProduto, acaoProdutoRepetido?: number) => void
  onLimparProdutosSelecionados: () => void
  processandoProduto: boolean
  produtoJaExisteNoOrcamento: (produto: IProduto) => boolean
}

export const ProdutosSelecionadosContext = React.createContext<ProdutosSelecionadosContextType>({
  desativarBotaoSelecionar: true,
  desativarBotaoAplicarItens: true,
  quantidadeItensSelecionados: 0,
  onSelecionar: () => { },
  onAplicarItens: async () => false,
  produtosSelecionados: [],
  onRemoverProduto: () => { },
  onRemoverTodasDuplicatasProduto: () => { },
  onAlterarQuantidade: () => { },
  onAlterarAcaoProdutoRepetido: () => { },
  onMostrarInformacoesProduto: () => { },
  onAdicionarProdutoSelecionado: () => { },
  onInserirProdutoDuplicadoSelecionado: () => { },
  onLimparProdutosSelecionados: () => { },
  processandoProduto: false,
  produtoJaExisteNoOrcamento: () => false,
});

// Mantem a identidade da funcao estavel entre renders (deps []), sempre executando a versao mais atual
// via ref — evita que handlers passados por Context/props invalidem memo() dos consumidores a cada render (APRENDIZADOS #21, #164)
function useStableCallback<T extends (...args: any[]) => any>(fn: T): T {
  const fnRef = useRef(fn);
  fnRef.current = fn;
  return useCallback(((...args: Parameters<T>) => fnRef.current(...args)) as T, []);
}

export const PaginaPesquisaProdutoContainer = (props: PaginaPesquisaProdutoContainerProps) => {
  const nomeGrid = "PESQUISAR_PRODUTOS_ORCAMENTO";

  const isMounted = useRef<boolean>(true)
  const dispatch = useAppDispatch()
  const produtosSelecionados = useAppSelector((store) => store.produtosSelecionados.produtos)
  const modalCestaProdutosAberto = useAppSelector((store) => store.produtosSelecionados.modalCestaProdutosAberto)
  const orcamento: IOrcamento = props.foraOrcamento || props.pesquisandoApenasParaFiltroProdutosLupa ? {} : useAppSelector((store) => store.orcamento);
  // 491123 — mesma checagem de ItensOrcamentoContainer.tsx: cobre o caso de um orçamento NOVO
  // (sem itens), que redireciona direto para esta tela sem ItensOrcamentoContainer chegar a
  // montar (ver ehParaRenderizarPesquisaDeProdutosImediatamente). O flag de módulo do hook garante
  // que a checagem roda só uma vez por carregamento de página, então tê-la nos dois lugares é seguro.
  useRecuperarCestaProdutosAnterior(props.chamadoParaInserirProdutoNoOrcamento ? orcamento : null)
  // 491123 — mesma restrição do hook acima: só faz sentido tentar recuperar o orçamento em
  // andamento quando esta tela foi aberta para inserir produtos NO orçamento (não em pesquisas
  // "fora do orçamento"/filtro de lupa, onde `orcamento` acima é sempre `{}`).
  useRecuperarOrcamentoEmAndamento(props.chamadoParaInserirProdutoNoOrcamento ? orcamento : null)
  const [parametros, setParametros] = useState<Parametro[]>([]);
  const mapaParametros = useMemo(() => new Map(parametros.map((p) => [p.Nome, p.Valor])), [parametros]);
  const valorParametro = useCallback((nome: string) => mapaParametros.get(nome), [mapaParametros]);
  const [processandoProduto, setProcessandoProduto] = useState<boolean>(false)
  //const [carregandoDadosIniciais, setCarregandoDadosIniciais] = useState<boolean>(true)
  const [mascara, setMacara] = useState<string>();
  const [colunas, setColunas] = useState<IColuna[]>([]);
  const [tamanhoFonte, setTamanhoFonte] = useState<number>(0);
  const [exibirFiltroEstoqueDisponivel, setExibirFiltroEstoqueDisponivel] = useState<boolean>(false);
  const [exibirFiltroEstoqueDisponivelOutrasFiliais, setExibirFiltroEstoqueDisponivelOutrasFiliais] = useState<boolean>(false);
  const [exibirTextoTecnico, setExibirTextoTecnico] = useState<boolean>(false);
  const [itensSelecionados, setItensSelecionados] = useState<IProduto[]>(props.itensSelecionados ?? []);
  const [exibirBotaoProdutosForaDoEstqoue, setExibirBotaoProdutosForaDoEstqoue,] = useState<boolean>(false);
  const [listaDisponibilidade, setListaDisponibilidade] = useState<Disponibilidade[]>([]);
  const [listaSistemaTintometrico, setListaSistemaTintometrico] = useState<ProdutoApi.ListaSistemaTintometrico[]>([]);
  const [permiteEngrenagemGrid, setPermiteEngrenagemGrid] = useState(false)
  const [permiteIncluirOrcamento, setPermiteIncluirOrcamento] = useState(false)
  const [parametrosCarregados, setParametrosCarregados] = useState(false)
  const [dadosPesquisaItens, setDadosPesquisaItens] = useState<PagedMessageResponse<IProduto>>(props.dadosGridPesquisaItens ?? null);
  const [tintasConfiguradas, setTintasConfiguradas] = useState<{ [codigo: string]: string }>({})
  const processando = useRef(false)
  const inputAutofocusRef = useRef(null)

  const setInputAutoFocus = () => { inputAutofocusRef.current && inputAutofocusRef.current.focus() }

  const [filtroPadrao, setFiltroPadrao] = useState<PesquisaProdutoPagina>({
    Classe: "",
    ClasseProduto: "",
    Codigo: "",
    CodigoFabricante: "",
    Descricao: "",
    Disponibilidade: [
      "32260",
      // "21081",
      // "21073",
      // "21077",
      // "21069",
      // "29105",
      // "32246",
      // "32410",
    ],
    EstoqueDisponivelOutrasFiliais: false,
    Fornecedor: "",
    ModeloProduto: "",
    NomeFornecedor: "",
    NumeroPagina: 1,
    Ordem: "ALFABETICA",
    ProdutoEmTransito: false,
    ProdutoOferta: false,
    Referencia: "",
    SistemaTintometrico: "",
    TamanhoPagina: 20,
    TextoTecnico: "",
    identificadorOrcamento: "",
  })

  const [filtros, setFiltros] = useState<PesquisaProdutoPagina>(props.filtroAnterior ?? filtroPadrao);
  const filtrosRef = useRef(filtros);
  filtrosRef.current = filtros;
  // refs de leitura para estabilizar identidade dos handlers via useCallback([]) sem depender de closures que mudam a cada render (APRENDIZADOS #21)
  const itensSelecionadosRef = useRef(itensSelecionados);
  itensSelecionadosRef.current = itensSelecionados;
  const dadosPesquisaItensRef = useRef(dadosPesquisaItens);
  dadosPesquisaItensRef.current = dadosPesquisaItens;
  const orcamentoRef = useRef(orcamento);
  orcamentoRef.current = orcamento;
  const produtosSelecionadosRef = useRef(produtosSelecionados);
  produtosSelecionadosRef.current = produtosSelecionados;
  const colunasRef = useRef(colunas);
  colunasRef.current = colunas;
  // 491123 — quantidades digitadas no stepper da coluna de seleção rápida
  // (itemPesquisaProduto_InputQuantidadeSelecaoRapida_), por código de produto. Necessário porque
  // ao paginar a grid é recarregada da API e cada linha (ItemPesquisaProduto) desmonta, perdendo o
  // useState local da quantidade; ao voltar para a página, a quantidade informada precisa reaparecer.
  // Ref e não state: só é lido no momento da nova busca, não deve provocar render.
  const quantidadesInformadasRef = useRef<{ [codigoProduto: string]: number }>({});
  const propsRef = useRef(props);
  propsRef.current = props;
  const [filtrouAlgumCheckboxEstoquesDisponivel, setFiltrouAlgumCheckboxEstoquesDisponivel] = useState<boolean>(false) // 435588
  const [produtosAgregadoExpandido, setProdutosAgregadoExpandido] = useState({})
  const [produtosAgregadoSugeridoExpandido, setProdutosAgregadoSugeridoExpandido] = useState({})
  const [iconeProdutoAgregadoExpandido, setIconeProdutoAgregadoExpandido] = useState<boolean>(false)
  const [iconeProdutoAgregadoSugeridoExpandido, setIconeProdutoAgregadoSugeridoExpandido] = useState<boolean>(false)
  const myRef = useRef(null)
  // Marca que a pesquisa que acabou de responder deve rolar a tela até a grade. O scroll NÃO pode
  // ser feito na própria função de pesquisa (ver #React-306): a grade só entra no DOM quando
  // `contexto.itens?.length > 0`, e isso só acontece no render seguinte ao setDadosPesquisaItens.
  // Na PRIMEIRA pesquisa a página ainda não tem altura para rolar, então o scrollIntoView vira um
  // no-op silencioso — a partir da segunda "funciona" porque a grade anterior já esticou a página.
  // Quem executa o scroll é o useEffect que observa `dadosPesquisaItens`, já com a grade montada.
  const deveRolarAteGradeRef = useRef(false)

  // #React-306 — o scroll acontece AQUI, e não dentro das funções de pesquisa: este efeito roda
  // depois do commit que montou a grade, que é o unico momento em que a página ja tem altura para
  // rolar. O ref-flag garante que so role em resposta a uma pesquisa, e nao a qualquer re-render
  // que mexa em `dadosPesquisaItens` (paginacao interna, atualizacao de markup, etc.).
  useEffect(() => {
    if (!deveRolarAteGradeRef.current) return
    deveRolarAteGradeRef.current = false
    myRef.current?.scrollIntoView({ behavior: "smooth" })
  }, [dadosPesquisaItens])

  // 491123 — código do produto configurado em "Selecionar Cor" que ainda precisa ser trazido ao
  // viewport; setado em onPesquisaAposCorSelecionada, consumido pelo useEffect de parametrosCarregados
  const produtoConfiguradoParaScrollRef = useRef<string | null>(null)

  const atualizarValoresParametros = async () => {
    if (!isMounted.current) return
    const resultado = await obterParametros({
      nomes: [
        "UTILIZA_SISTEMA_TINTOMETRICO",
        "PRODUTO_EM_TRANSITO",
        "PROD_SEM_EST",
        "VISUALIZA_MARKUP_PRODUTO_ORCAMENTO",
        "EXIBIR_ESTOQUE_OUTRAS_FILIAIS",
        "EXIBIR_COLUNA_ESTOQUE_TOTAL_PRODUTO_VENDAS",
        "ORCWEB_UTILIZA_DESCONTO_MAXIMO_BONIFICACAO_AVANCADOS",
        "EXIBIR_PRECO_COMISSAO_NA_CONSULTA_PRODUTOS",
        "APRESENTAR_LOCAL_FISICO_CONSULTA_PRODUTO",
        "EXIBE_LOCAL_FISICO_CONSULTA_PRODUTOS",
        "CONTROLE_LOTE_TONALIDADE", //435588
        "PROD_SEM_EST",
        "CHAVE_MOVIMENTACAO_ORCAMENTO",
        "CHAVEMOVIMFL",
        "CHAVEMOVIM"
      ],
    });
    if (!isMounted.current) return
    setParametros(resultado);
  };

  const permitidoAcaoFuncionalidade = async (
    siglaFuncionalidade: string,
    acao?: string
  ) => await obterPermissao({ funcionalidade: siglaFuncionalidade, acao });

  const atualizarExibicaoEstoques = async () => {
    const [filtroDisponivel, filtroOutrasFiliais] = await Promise.all([
      permitidoAcaoFuncionalidade("ORCAMENTO_PESQUISAR_PRODUTO", "FILTRO_ESTOQUE_DISPONIVEL"),
      permitidoAcaoFuncionalidade("ORCAMENTO_PESQUISAR_PRODUTO", "FILTRO_ESTOQUE_DISPONIVEL_OUTRAS_FILIAIS"),
    ]);
    if (!isMounted.current) return;
    setExibirFiltroEstoqueDisponivel(filtroDisponivel);
    setExibirFiltroEstoqueDisponivelOutrasFiliais(filtroOutrasFiliais);
  };

  const atualizarExibicaoTextoTecnico = async () => {
    if (!isMounted.current) return
    const respota = await permitidoAcaoFuncionalidade(
      "ORCAMENTO_PESQUISAR_PRODUTO",
      "EXIBIR_TEXTO_TECNICO"
    )
    if (!isMounted.current) return
    setExibirTextoTecnico(respota);
  };

  const atualizarPermissaoIncluirOrcamento = async () => {
    if (!isMounted.current) return
    const respota = await permitidoAcaoFuncionalidade(
      "ORCAMENTO_ITEM_VENDA",
      "INCLUIR"
    )
    if (!isMounted.current) return
    setPermiteIncluirOrcamento(respota);
  };

  const atualizarExibicaoBotaoProdutosForaDoEstoque = async () => {
    if (!isMounted.current) return
    const respota = await permitidoAcaoFuncionalidade(
      "ORCAMENTO_ITEM_VENDA",
      "INSERIR_PRODUTOS_FORA_ESTOQUE"
    )
    if (!isMounted.current) return
    setExibirBotaoProdutosForaDoEstqoue(respota);
  };

  const obterDadosIniciaisGrid = async () => {
    if (!isMounted.current) return
    try {
      //globalMU.blockUI();
      const dadosInicias = await microuniversoApi.Seguranca.obterDadosGrid("Orcamento", nomeGrid);
      if (!isMounted.current) return
      setColunas(dadosInicias.Colunas);
      setTamanhoFonte(dadosInicias.TamanhoFonte);
    } catch (e) {
      
      tratamentoErroPadrao(e);
    } finally {
      //globalMU.unblockUI();
    }
  };

  const toggleColunaSelecionada = useCallback(async (
    nomeColuna: string,
    selecionada: boolean
  ) => {
    if (!isMounted.current) return
    let coluna = { ...colunasRef.current.find((c) => c.Nome == nomeColuna) };
    coluna.Selecionada = selecionada;

    const colunas_ = substituirItemEmArray(
      colunasRef.current,
      (coluna) => coluna.Nome == nomeColuna,
      coluna
    );

    setColunas(colunas_);

    await microuniversoApi.Seguranca.atualizarColunasGrid(colunas_, nomeGrid);
  }, []);

  const toggleSelecionarTodasColunas = useCallback(async (selecionar: boolean) => {
    if (!isMounted.current) return
    const colunas_ = colunasRef.current.map(
      (c) => ({ ...c, Selecionada: selecionar } as IColuna)
    );
    setColunas(colunas_);
    await microuniversoApi.Seguranca.atualizarColunasGrid(colunas_, nomeGrid);
  }, []);

  const alterarFonte = useCallback(async (tamanho: number) => {
    if (!isMounted.current) return
    globalMU.blockUI();
    try {
      await microuniversoApi.Usuario.alterarFonte(nomeGrid, tamanho);
      globalMU.unblockUI();
    } catch (e) {
      tratamentoErroPadrao(e);
      globalMU.unblockUI();
    }
  }, []);

  const obterDisponibilidades = async () => {
    if (!isMounted.current) return
    try {
      //globalMU.blockUI();
      const disponibilidades = await microuniversoApi.Produto.ObterDisponibilidades();
      if (!isMounted.current) return

      const codigosDisponibilidades = disponibilidades
        .filter((d) => d.Codigo != 21085) //21085 -> Não disponível para venda
        .map((d) => d.Codigo.toString()) // 487027


      if (codigosDisponibilidades.filter((cd) => cd == "21085").length > 0) {
        globalMU.showErrorMessage("Ocorreu um erro ao carregar disponibilidades. Entre em contato com o suporte") // so para garantir q nao vai fazer errado
      }

      const filtroPadraoAlterado = { ...filtroPadrao, Disponibilidade: codigosDisponibilidades } // 487027

      setFiltroPadrao(filtroPadraoAlterado) // 487027
      if (!props.filtroAnterior) {
        setFiltros(filtroPadraoAlterado);
      } else {
        setFiltros(prev => ({ ...filtroPadraoAlterado, ...prev }));
      }
      setListaDisponibilidade(disponibilidades);
    } catch (e) {
      tratamentoErroPadrao(e);
    } finally {
      //globalMU.unblockUI();
    }
  };

  // memoizado: evita repetir os 3 lookups de parametro e a normalizacao a cada render (so recalcula quando os parametros mudam)
  const chaveMovimentacaoEhReferencia = useMemo(() => {
    const valor1 = valorParametro("CHAVE_MOVIMENTACAO_ORCAMENTO");
    const valor2 = valorParametro("CHAVEMOVIMFL");
    const parametroChaveMovimentacao = !globalMU.isNullOrEmpty(valor1)
      ? valor1
      : !globalMU.isNullOrEmpty(valor2)
        ? valor2
        : valorParametro("CHAVEMOVIM");

    return (parametroChaveMovimentacao ?? "").toUpperCase() === "R";
  }, [valorParametro]);

  const obterListarSistemaTintometrico = async () => {
    if (!isMounted.current) return
    try {
      //globalMU.blockUI();
      const resposta = await microuniversoApi.Produto.listarSistemaTintometrico();
      if (!isMounted.current) return
      setListaSistemaTintometrico(resposta);
    } catch (e) {
      tratamentoErroPadrao(e);
    } finally {
      //globalMU.unblockUI();

    };
  }

  const _validarFiltroEstoque = useCallback(async () => {
    if (!isMounted.current) return

    const filtrosAtuais = filtrosRef.current

    if (!filtrosAtuais.EstoqueDisponivelFilialCorrente && !filtrosAtuais.EstoqueDisponivelOutrasFiliais && !filtrosAtuais.EstoqueDisponivelCD)
      filtrosAtuais.TipoFiltroEstoque = null

    if (filtrosAtuais.TipoFiltroEstoque != undefined && filtrosAtuais.TipoFiltroEstoque != null) {
      if (filtrosAtuais.TipoFiltroEstoque == "Entre") {
        if (filtrosAtuais.QuantidadeInicialFiltroEstoque == undefined || filtrosAtuais.QuantidadeInicialFiltroEstoque == null || filtrosAtuais.QuantidadeInicialFiltroEstoque == 0) {
          globalMU.showErrorMessage("Quantidade inicial não informada")
          return false
        }
        if (filtrosAtuais.QuantidadeFinalFiltroEstoque == undefined || filtrosAtuais.QuantidadeFinalFiltroEstoque == null || filtrosAtuais.QuantidadeFinalFiltroEstoque == 0) {
          globalMU.showErrorMessage("Quantidade final não informada")
          return false
        }
        if (filtrosAtuais.QuantidadeFinalFiltroEstoque < filtrosAtuais.QuantidadeFinalFiltroEstoque) {
          globalMU.showErrorMessage("Quantidade final não pode ser menor que a quantidade inicial")
          return false
        }
      }
      else if (filtrosAtuais.TipoFiltroEstoque != "" && (filtrosAtuais.QuantidadeInicialFiltroEstoque == undefined || filtrosAtuais.QuantidadeInicialFiltroEstoque == null || filtrosAtuais.QuantidadeInicialFiltroEstoque == 0)) {
        globalMU.showErrorMessage("Quantidade não informada")
        return false
      }
    }
    return true
  }, [])

  const pesquisaPaginada = useCallback(async (numeroIndexPagina: number) => {
    if (!isMounted.current) return
    // qualquer alteracao nesse metodo tem que verificar tambem o "onPesquisar"
    globalMU.blockUI();
    try {
      setProcessandoProduto(true)
      const filtrosAtuais = filtrosRef.current
      const filtrosAlterado = { ...filtrosAtuais, NumeroPagina: numeroIndexPagina };
      if (! await _validarFiltroEstoque())
        return false
      const produtos = await microuniversoApi.Produto.pesquisarProduto(
        filtrosAlterado
      );
      if (!isMounted.current) return

      itensSelecionadosRef.current?.forEach((item) => {
        var prod = produtos?.Entities?.find((produto) => produto.Codigo == item.Codigo) // 437794
        if (prod) {
          prod.Quantidade = item.Quantidade // 437794
          prod.AcaoProdutoRepetido = item.AcaoProdutoRepetido // 437794
        }

      })

      // 491123 — restaura a quantidade digitada no stepper da coluna de seleção rápida ao voltar
      // para uma página já visitada. Vem DEPOIS do bloco 437794 de propósito: aquele só cobre
      // produtos SELECIONADOS, enquanto este mapa é o registro fiel do que o usuário informou,
      // independente de seleção — então precisa ter a última palavra.
      produtos?.Entities?.forEach((produto) => {
        const quantidadeInformada = quantidadesInformadasRef.current[produto.Codigo]
        if (quantidadeInformada != null) {
          produto.Quantidade = quantidadeInformada
        }
      })

      setDadosPesquisaItens(produtos);
      deveRolarAteGradeRef.current = true
      produtos?.RowsCount >= 100 && ((filtrosAtuais.MarkupInicial && parseFloat(filtrosAtuais.MarkupInicial) !== 0) || ((filtrosAtuais.MarkupFinal && parseFloat(filtrosAtuais.MarkupFinal) !== 0))) &&
        produtos?.Entities?.[0].MarkupCalculado == null && globalMU.showWarnMessage("Filtro do markup não foi aplicado, pesquisa retornou muitos registros.<br><br>Incluia mais filtros para poder conseguir aplicar o filtro de markup.");
      globalMU.unblockUI();


      obterMarkupProdutosJaPesquisados(produtos)
    } catch (e) {
      tratamentoErroPadrao(e);
    } finally {
      if (isMounted.current) {
        setProcessandoProduto(false)
      }
      globalMU.unblockUI();
    }
  }, [_validarFiltroEstoque]);

  const onPesquisar = useCallback(async () => { // qualquer alteracao nesse metodo tem que verificar tambem o "pesquisaPaginada"
    if (!isMounted.current) return
    try {
      globalMU.blockUI();
      setProcessandoProduto(true)
      setItensSelecionados([]) // 465686

      const filtrosAtuais = filtrosRef.current
      filtrosAtuais.identificadorOrcamento = orcamentoRef.current.IdentificadorOrcamento
      if (! await _validarFiltroEstoque())
        return false
      const produtos = await microuniversoApi.Produto.pesquisarProduto(filtrosAtuais);
      if (!isMounted.current) return

      setDadosPesquisaItens(produtos);
      setItensSelecionados([])
      if (produtos?.RowsCount == 1) {
        setItensSelecionados([produtos?.Entities?.[0]]) // se so tem 1 produto, ja pode selecionar
      }

      deveRolarAteGradeRef.current = true
      produtos?.RowsCount >= 100 && ((filtrosAtuais.MarkupInicial && parseFloat(filtrosAtuais.MarkupInicial) !== 0) || ((filtrosAtuais.MarkupFinal && parseFloat(filtrosAtuais.MarkupFinal) !== 0))) &&
        produtos?.Entities?.[0].MarkupCalculado == null && globalMU.showWarnMessage("Filtro do markup não foi aplicado, pesquisa retornou muitos registros.<br><br>Incluia mais filtros para poder conseguir aplicar o filtro de markup.");
      // (produtos.RowsCount || 0) > 0 && produtos.Entities[0].MarkupCalculado == null && valorParametro("VISUALIZA_MARKUP_PRODUTO_ORCAMENTO") === "S" &&

      const deveExpandirAgregadoSugeridoAutomatico = produtos?.Entities?.length == 1 && produtos?.Entities[0].TemProdutoAgregadoSugerido
      const deveExpandirAgregadoAutomatico = produtos?.Entities?.length == 1 && produtos?.Entities[0].TemProdutoAgregado

      if (deveExpandirAgregadoSugeridoAutomatico) {
        onPesquisarProdutoAgregadoSugerido(produtos?.Entities?.[0], produtos, filtrosAtuais.Ordem)
        setProdutosAgregadoSugeridoExpandido({ [produtos?.Entities?.[0].CodigoProduto]: true })
        setItensSelecionados([produtos?.Entities?.[0]])
        setIconeProdutoAgregadoSugeridoExpandido(true)

      }

      if (deveExpandirAgregadoAutomatico) {
        onPesquisarProdutoComAgregado(produtos?.Entities?.[0], produtos, filtrosAtuais.Ordem)
        setProdutosAgregadoExpandido({ [produtos?.Entities?.[0].CodigoProduto]: true })
        setItensSelecionados([produtos?.Entities?.[0]])
        setIconeProdutoAgregadoExpandido(true)
      }

      obterMarkupProdutosJaPesquisados(produtos)
    } catch (e) {
      tratamentoErroPadrao(e);
    } finally {
      if (isMounted.current) {
        setProcessandoProduto(false)
      }
      globalMU.unblockUI();
    }
  }, [_validarFiltroEstoque]);

  const atualizarPermiteEngrenagemGrid = async () => {
    if (!isMounted.current) return
    const respota = await permitidoAcaoFuncionalidade("ORCAMENTO_ACESSO_ENGRENAGEM_GRID")
    if (!isMounted.current) return
    setPermiteEngrenagemGrid(respota)
  }

  const mascaraClasseProduto = async () => {
    if (!isMounted.current) return
    try {
      //globalMU.blockUI();
      const mascaraClasse = await microuniversoApi.Produto.mascaraClasseProduto();
      if (!isMounted.current) return
      setMacara(mascaraClasse);
    } catch (e) {
      tratamentoErroPadrao(e);
    } finally {
      //globalMU.unblockUI();
    }
  };

  const pesquisaAnterior = async (filtro: string) => {
    if (!isMounted.current) return
    globalMU.blockUI();
    try {
      let filtrosConvertido = JSON.parse(filtro) as PesquisaProdutoPagina;
      Object.keys(filtrosConvertido).forEach(key => {
        if (filtrosConvertido[key] === null || key == "IdentificadorOrcamento") {
          delete filtrosConvertido[key];
        }
      });
      let filtrosAlterado = filtrosConvertido
      setFiltros({
        ...filtrosAlterado,
        identificadorOrcamento: orcamento.IdentificadorOrcamento,
      });
      const produtos = await microuniversoApi.Produto.pesquisarProduto({
        ...filtrosAlterado,
        IdentificadorOrcamento: orcamento.IdentificadorOrcamento,
      });
      if (!isMounted.current) return
      setDadosPesquisaItens(produtos);
      deveRolarAteGradeRef.current = true
      globalMU.unblockUI();
    } catch (e) {
      tratamentoErroPadrao(e);
    } finally {
      globalMU.unblockUI();
    }
  };

  const onPesquisaAposCorSelecionada = async () => {
    if (!isMounted.current) return
    globalMU.blockUI();
    try {
      let itemCorSelecionado = dadosPesquisaItens?.Entities?.filter((item) => item.Configurado) ?? []
      const listaItensTinta = Object.values(itemCorSelecionado).map(({ Codigo }) => ([[Codigo], "verde"]));
      const objetoItensTinta = Object.fromEntries(listaItensTinta);
      setTintasConfiguradas(objetoItensTinta)

      // 491123 — ao voltar de "Selecionar Cor" (PesquisaCor_botaoOk), o produto configurado pode
      // estar fora do viewport (grid com muitos resultados) — trazer a linha dele à vista. Só
      // GUARDAR o código aqui: a grade (GridItensPesquisaProdutos) ainda não está no DOM neste
      // momento (fica escondida atrás de "Carregando... Aguarde!" até parametrosCarregados virar
      // true, ver render mais abaixo) — o scroll de fato acontece no useEffect que observa
      // parametrosCarregados.
      produtoConfiguradoParaScrollRef.current = itemCorSelecionado[0]?.CodigoProduto ?? null

      globalMU.unblockUI();
    } catch (e) {
      tratamentoErroPadrao(e);
    } finally {
      globalMU.unblockUI();
    }
  };

  const pesquisaPreVenda = async (preVendasSelecionado: PreVenda[]) => {
    
    if (!isMounted.current) return
    globalMU.blockUI();
    try {
      let produtosAlterados = []
      let itensPreVenda = preVendasSelecionado.flatMap((i) => i.ItensPreVenda)
      const codigosItemVenda = preVendasSelecionado.flatMap((i) => i.ItensPreVenda.map((a) => a.CodigoProduto));
      const preVendasAgrupadas = itensPreVenda.reduce((a, c) => {
        a.find(item => item.CodigoProduto === c.CodigoProduto && item.TipoEntregaDefinido === c.TipoEntregaDefinido) ? (
          a[a.findIndex(object => object.CodigoProduto === c.CodigoProduto && object.TipoEntregaDefinido === c.TipoEntregaDefinido)].Quantidade += c.Quantidade
        ) : a.push(c);
        return a;
      }, []);

      const produtos = await microuniversoApi.Produto.pesquisarProduto({
        Codigos: codigosItemVenda,
        TamanhoPagina: 9999
      });
      if (!isMounted.current) return

      (produtos?.Entities ?? []).forEach((x) =>
        preVendasAgrupadas.map((y) => y.CodigoProduto == x.Codigo && produtosAlterados.push({ ...x, TipoEntregaPedido: y.TipoEntregaDefinido, Quantidade: y.Quantidade }))
      )

      // Pré-venda selecionada: os produtos vão direto para a cesta (sem passar pela grade de
      // pesquisa/GridItensPesquisaProdutos_TabelaProdutos) e o modal da cesta já abre em seguida,
      // para o usuário revisar/ajustar antes de aplicar ao orçamento.
      if (produtosAlterados.length > 0) {
        dispatch(selecionarProdutosAction(produtosAlterados.map(ajustarQuantidadeMinimaAoAdicionar)))
        dispatch(abrirModalCestaProdutosAction())
      }

      globalMU.unblockUI();
    } catch (e) {
      tratamentoErroPadrao(e);
    } finally {
      globalMU.unblockUI();
    }
  };

  const onSelecionarProdutos = useStableCallback((itens: IProduto[]) => {

    if (itens.length == 1) {
      const menuConsultaProdutosController = new MenuConsultaProdutosController({
        controller: window.orcamentoController,
        orcamento: new Backbone.Model(orcamentoRef.current),
        model: new Backbone.Model(itens[0]),
        adicionarProdutosCallback: $.proxy(propsRef.current.adicionarProdutosCallBack, this)
      });

      //menuConsultaProdutosController.show();
    } else {
      //new MenuConsultaProdutosController().hide()
    }

    setItensSelecionados(itens);
  })

  const onToggleProdutoSelecionado = useCallback((item: IProduto) => {
    if (!isMounted.current) return
    const itensAtuais = itensSelecionadosRef.current
    if (itensAtuais?.find((produto) => produto.CodigoProduto == item.CodigoProduto) != undefined) {
      setItensSelecionados(
        R.filter((c) => c.CodigoProduto != item.CodigoProduto, itensAtuais)
      );
      onSelecionarProdutos(
        R.filter((c) => c.CodigoProduto != item.CodigoProduto, itensAtuais)
      );
    } else {
      setItensSelecionados(itensAtuais.concat(item));
      onSelecionarProdutos(itensAtuais.concat(item));
    }
  }, [onSelecionarProdutos]);

  const onSelecionarTodos = useCallback(() => {
    if (!isMounted.current) return
    const itensAtuais = itensSelecionadosRef.current
    const dadosPesquisaAtuais = dadosPesquisaItensRef.current
    const todasEntidades = dadosPesquisaAtuais?.Entities ?? []

    // 491123 — o botão age só sobre as linhas REALMENTE renderizadas no tbody
    // (GridItensPesquisaProdutos_CorpoTabelaProdutos). Entities pode conter linhas ocultas: filhos
    // de produto agregado/agregado sugerido já carregados mas com o pai recolhido são filtrados
    // fora do tbody (produtoAgregadoOcultado/produtoAgregadoSugeridoOcultado, em
    // GridItensPesquisaProdutos). Sem esse recorte, "Selecionar todos" marcaria produtos que o
    // usuário não está vendo — e eles entrariam no orçamento ao aplicar os itens.
    // O recorte vem do DOM em vez de uma cópia da regra de ocultação aqui: a regra depende do
    // estado de expansão que é local à grid, e duplicá-la deixaria as duas versões divergindo.
    const corpoTabela = document.getElementById("GridItensPesquisaProdutos_CorpoTabelaProdutos")
    let entidadesPagina = todasEntidades
    if (corpoTabela != null) {
      // corpoTabela presente mas sem linhas = nada visível para selecionar (Set vazio). Já a
      // AUSÊNCIA do elemento significa "não deu para saber quais estão visíveis" — nesse caso
      // mantém todasEntidades, para o botão nunca virar um no-op silencioso.
      const codigosVisiveis = new Set(
        Array.from(corpoTabela.querySelectorAll('tr[id^="ItemPesquisaProduto_LinhaTabela_"]'))
          .map((linha) => linha.id.replace("ItemPesquisaProduto_LinhaTabela_", ""))
      )
      // O id da linha (ItemPesquisaProduto_LinhaTabela_${item.Codigo}) usa item.Codigo, não
      // CodigoProduto (ver ItemPesquisaProduto.tsx) — o recorte por "o que está visível no DOM"
      // tem que casar pela mesma chave, senão o Set nunca bate com nada e o botão vira um no-op.
      entidadesPagina = todasEntidades.filter((item) => codigosVisiveis.has(item.Codigo))
    }

    // Botão "Selecionar todos": se algum produto da página ainda não está em itensAtuais,
    // adiciona TODOS os produtos da página (sem repetição); se a página inteira já está
    // selecionada, remove todos os produtos da página de itensAtuais.
    // A partir daqui a comparação usa CodigoProduto — a MESMA chave usada por itensAtuais/
    // onToggleProdutoSelecionado/estado visual "selecionado" da linha (GridItensPesquisaProdutos).
    // Só o recorte de visibilidade acima (DOM) usa Codigo; o restante do rastreamento de seleção
    // continua em CodigoProduto — não confundir as duas chaves nem tentar unificar sem conferir
    // os dois lados primeiro.
    const algumProdutoDaPaginaNaoSelecionado = entidadesPagina.some(
      (item) => !itensAtuais.some((i) => i.CodigoProduto === item.CodigoProduto)
    );

    // 491123 — ao adicionar, preservar itensAtuais INTEIRO e só concatenar o que falta. Filtrar de
    // itensAtuais os produtos da página (como era feito antes) desselecionava justamente as linhas
    // que já estavam marcadas: elas saíam do primeiro trecho (estão na página) e não entravam no
    // segundo (já estavam selecionadas) — o botão invertia a seleção em vez de completá-la.
    // Manter os objetos de itensAtuais também preserva o estado por item (quantidade, cor de tinta).
    const novosItensSelecionados = algumProdutoDaPaginaNaoSelecionado
      ? [
          ...itensAtuais,
          ...entidadesPagina.filter((item) => !itensAtuais.some((i) => i.CodigoProduto === item.CodigoProduto)),
        ]
      : itensAtuais.filter((i) => !entidadesPagina.some((item) => item.CodigoProduto === i.CodigoProduto));
    setItensSelecionados(novosItensSelecionados);
  }, [])

  const onAdicionarProdutosSelecionados = useCallback(() => {
    if (!isMounted.current) return

    const itensAtuais = itensSelecionadosRef.current
    const produtosSelecionadosAtuais = produtosSelecionadosRef.current

    // 491123 — as duas mensagens são independentes: numa mesma ação pode haver produtos ignorados
    // (já estavam na cesta) E produtos adicionados, e nesse caso o usuário vê as duas.
    const produtosJaSelecionados = itensAtuais.filter((item) =>
      produtosSelecionadosAtuais.some((produtoSelecionado) => produtoSelecionado.Codigo == item.Codigo)
    )
    if (produtosJaSelecionados.length > 0) {
      const quantidade = produtosJaSelecionados.length
      globalMU.showWarnMessage(quantidade === 1
        ? "1 produto não foi adicionado, pois já estava na cesta."
        : `${quantidade} produtos não foram adicionados, pois já estavam na cesta.`)
    }

    const produtosNovos = itensAtuais.filter((item) =>
      !produtosSelecionadosAtuais.some((produtoSelecionado) => produtoSelecionado.Codigo == item.Codigo)
    )
    if (produtosNovos.length > 0) {
      dispatch(selecionarProdutosAction(produtosNovos.map(ajustarQuantidadeMinimaAoAdicionar)))
      const quantidade = produtosNovos.length
      globalMU.showSuccessMessage(quantidade === 1
        ? "1 produto adicionado à cesta."
        : `${quantidade} produtos adicionados à cesta.`)
    }

    setItensSelecionados([])
  }, [dispatch])

  const onAdicionarProdutoSelecionado = useCallback((produto: IProduto) => {
    if (!isMounted.current) return

    if (produtosSelecionadosRef.current.some((produtoSelecionado) => produtoSelecionado.Codigo == produto.Codigo)) {
      
      globalMU.showWarnMessage(`Produto [${produto.CodigoProdutoExibicao}] já selecionado`)
      return
    }

    dispatch(selecionarProdutosAction([ajustarQuantidadeMinimaAoAdicionar(produto)]))
    globalMU.showSuccessMessage(`Produto ${produto.Codigo} adicionado à cesta`)
    setItensSelecionados(itensSelecionadosRef.current.filter((item) => item.CodigoProduto != produto.CodigoProduto))
  }, [dispatch])

  // 491123 — "Inserir Novo" no dropdown do local_mall: cria uma nova linha (duplicata) na cesta
  // a cada clique, em vez de só marcar uma ação para o backend resolver depois. Vale tanto quando
  // o produto ainda NÃO existe no orçamento (só está na cesta) quanto quando já existe (Repetido)
  // — nesse segundo caso o chamador deve passar acaoProdutoRepetido=0, porque o backend exige essa
  // marcação em toda linha Repetido antes de aplicar a cesta (ver validação em onAdicionarItensGrid).
  // A cesta identifica cada linha pelo campo IdentificadorLinhaCesta (ver produtosSelecionadosSlice.ts)
  // — NUNCA por Codigo, que precisa continuar sendo o código real do produto (é o que é enviado à
  // API em CriarItemOrcamentoContract.Codigo ao aplicar os itens). A duplicata recebe um
  // IdentificadorLinhaCesta sintético para não substituir a linha já existente, mantendo Codigo intacto.
  const onInserirProdutoDuplicadoSelecionado = useCallback((produto: IProduto, acaoProdutoRepetido: number = null) => {
    if (!isMounted.current) return

    const duplicatasExistentes = produtosSelecionadosRef.current.filter(
      (produtoSelecionado) => produtoSelecionado.CodigoProduto == produto.CodigoProduto
    ).length

    dispatch(selecionarProdutosAction([ajustarQuantidadeMinimaAoAdicionar({
      ...produto,
      IdentificadorLinhaCesta: `${produto.CodigoProduto}_${duplicatasExistentes + 1}`,
      AcaoProdutoRepetido: acaoProdutoRepetido,
    })]))
  }, [dispatch])

  const onLimparProdutosSelecionados = useCallback(() => {
    if (!isMounted.current) return
    dispatch(limparProdutosSelecionadosAction())
    dispatch(fecharModalCestaProdutosAction())
  }, [dispatch])

  const onFecharModalCestaProdutos = useCallback(() => {
    // sem guard de isMounted: é um dispatch puro no redux, não faz setState deste componente,
    // e precisa fechar o modal mesmo quando chamado após onVoltar() já ter desmontado este
    // container (ex: ao aplicar itens da cesta, que navega de volta para Itens antes de fechar o modal)
    dispatch(fecharModalCestaProdutosAction())
  }, [dispatch])

  const onRemoverProdutoSelecionado = useCallback((produto: IProduto) => {
    if (!isMounted.current) return
    // 491123 — usar o identificador de linha (não Codigo): duas linhas duplicadas do mesmo
    // produto compartilham Codigo, então remover por Codigo removeria as duas de uma vez
    dispatch(removerProdutoSelecionadoAction(produto.IdentificadorLinhaCesta ?? produto.Codigo))
  }, [dispatch])

  // 491123 — usado pelo botão de remover da GRADE de pesquisa (itemPesquisaProduto_BotaoDeleteCesta_):
  // esse botão representa o PRODUTO (não uma linha específica da cesta), então se o mesmo produto
  // tiver sido duplicado na cesta ("Inserir Novo"), remove TODAS as duplicatas de uma vez.
  const onRemoverTodasDuplicatasProdutoSelecionado = useCallback((produto: IProduto) => {
    if (!isMounted.current) return
    dispatch(removerTodasDuplicatasProdutoSelecionadoAction(produto.CodigoProduto))
    globalMU.showSuccessMessage(`Produto ${produto.Codigo} removido`)
  }, [dispatch])

  const onAlterarQuantidadeProdutoSelecionado = useCallback((produto: IProduto, quantidade: number) => {
    if (!isMounted.current) return

    let quantidadeAjustada = quantidade

    // 490958 - ajusta a quantidade informada para o múltiplo mais próximo da Venda Mínima.
    // Sem Venda Mínima (ou <= 0), considera 1 — quantidade precisa ser um número inteiro.
    //const quantidadeMinimaVenda = produto.MenorFracaoVenda
    const quantidadeMinimaVendaEfetiva = produto.MenorFracaoVenda > 0 ? produto.MenorFracaoVenda : 1
    const divisaoExata = Number((quantidadeAjustada / quantidadeMinimaVendaEfetiva).toFixed(6))
    const divisaoTruncada = Math.floor(divisaoExata)
    if (produto.MenorFracaoVenda > 0 && divisaoExata != divisaoTruncada) { // 490958 - 493081
      quantidadeAjustada = quantidadeMinimaVendaEfetiva * (divisaoTruncada + 1)
      globalMU.showWarnMessage(`Quantidade deverá ser múltiplo de: ${globalMU.formatarValorNumerico(produto.MenorFracaoVenda, 3, false)}`)
    }

    // 491123 — identificador de linha, não Codigo (ver onRemoverProdutoSelecionado)
    dispatch(atualizarQuantidadeProdutoSelecionadoAction({ codigo: produto.IdentificadorLinhaCesta ?? produto.Codigo, quantidade: quantidadeAjustada }))
  }, [dispatch])

  const onAlterarAcaoProdutoRepetidoSelecionado = useCallback((produto: IProduto, acao: number) => {
    if (!isMounted.current) return
    // 491123 — identificador de linha, não Codigo (ver onRemoverProdutoSelecionado)
    dispatch(atualizarAcaoProdutoRepetidoSelecionadoAction({ codigo: produto.IdentificadorLinhaCesta ?? produto.Codigo, acao }))
  }, [dispatch])

  const produtoJaExisteNoOrcamento = useCallback((produto: IProduto) =>
    (orcamento.ItensOrcamento ?? []).some((itemOrcamento) => itemOrcamento.Codigo == produto.Codigo),
    [orcamento.ItensOrcamento]
  )

  const desativarBotaoAcoes = useMemo(() =>
    itensSelecionados.filter((item) => orcamento.ItensOrcamento?.find((itemOrcamento) => itemOrcamento.Codigo == item.Codigo)).length <= 0,
    [itensSelecionados, orcamento.ItensOrcamento]
  )

  const onMostrarInformacoesProduto = useStableCallback((item: IProduto) => {
    // 491123 — "Informações" também é clicável direto da cesta (TabelaProdutosSelecionados),
    // mesmo risco do botão de tinta: sem surgir em tela cheia, DetalhesProdutoContainer nasceria
    // dentro do host oculto, invisível ao usuário.
    const subFluxo = prepararSubFluxoTelaCheia(funcaoRetornaPagina)
    if (!subFluxo) return

    renderizarComponentReact(
      <DetalhesProdutoContainer
        key="PaginaPesquisaProdutoContainer_DetalhesProdutoContainer"
        desabilitarPesquisarHistorico={propsRef.current.desabilitarPesquisarHistorico}
        mascara=""
        produto={item}
        orcamentoForaModuloVendas={propsRef.current.foraOrcamento}
        regiaoRenderizada={subFluxo.regiaoRenderizada}
        onVoltar={subFluxo.onVoltarTelaCheia}
        passos={passosInterno.current}
      />,
      subFluxo.regiaoRenderizada,
      true
    )
  })

  const onAplicarItens = useStableCallback(async () => {

    return await onAdicionarItensGrid(
      false, 
      produtosSelecionadosRef.current, 
      () => dispatch(limparProdutosSelecionadosAction()), 
      "Aguarde, isso pode levar alguns instantes.")
  })

  const onPesquisarInserirContinuar = useStableCallback(async () => {
    if (!isMounted.current) return
    globalMU.blockUI()

    try {
      if (processando.current) return true
      processando.current = true
      setItensSelecionados([]) // 465686

      const filtros = filtrosRef.current
      const orcamento = orcamentoRef.current
      const props = propsRef.current
      let filtroPesquisa = { ...filtros, identificadorOrcamento: orcamento.IdentificadorOrcamento }
      const resultadoPesquisa = await microuniversoApi.Produto.pesquisarProduto(filtroPesquisa)
      if (!isMounted.current) return

      if (resultadoPesquisa?.Entities?.length > 0)
        setDadosPesquisaItens(resultadoPesquisa);
      if (!("Error" in resultadoPesquisa)) {

        const { podeSerAdicionado, mensagensValidacao } = resultadoPesquisa?.Entities?.length > 1 ?
          { podeSerAdicionado: false, mensagensValidacao: ["A pesquisa retornou mais de um resultado, não será possível adicionar o produto automaticamente"] } :
          produtoPodeSerAdicionadoAutomaticamenteAoOrcamento(resultadoPesquisa?.Entities?.[0], orcamento, true, true)

        if (podeSerAdicionado) {
          if (props.adicionarProdutos) {
            props.adicionarProdutos(resultadoPesquisa?.Entities ?? [])
          }
          else {
            const respostaInsercaoProdutos = await adicionarProdutos(orcamento.IdentificadorOrcamento, (resultadoPesquisa?.Entities ?? []))
            if (!isMounted.current) return
            if (respostaInsercaoProdutos.status == "SUCESSO") {

              if ((mensagensValidacao ?? []).length == 0) {
                globalMU.showSuccessMessage("Item adicionado com sucesso")
              }

              const orcamentoAtualizado = store.getState().orcamento

              const existemProdutosMadeiraNaoConfigurados = (orcamentoAtualizado.ItensOrcamento ?? []).some(i => i.Madeira && i.DadosMadeira == null)

              if (existemProdutosMadeiraNaoConfigurados) {
                renderizarComponentReact(
                  <TratamentoMadeiraContainer
                    somenteLeitura={orcamento == null || orcamento.SomenteLeitura}
                    key="PaginaPesquisaProdutoContainer_TratamentoMadeiraContainer"
                    onFinalizarConfiguracaoProdutos={() => {
                      renderizarComponentReact(
                        <PaginaPesquisaProdutoContainer {...props}
                        />, "conteudo-pagina", true
                      )
                    }}
                    onCancelar={() => {
                      renderizarComponentReact(
                        <PaginaPesquisaProdutoContainer {...props}
                        />, "conteudo-pagina", true
                      )
                    }}
                  />, "conteudo-pagina", true
                )
              } else {
                setFiltros(filtroPadrao);
                setDadosPesquisaItens({});


              }


            }
          }
        }
        await forEachSeries((mensagensValidacao ?? []), mensagem => new Promise<void>(resolve => {
          setTimeout(() => {
            globalMU.showWarnMessage(mensagem)
            resolve()
          }, 500)
        }))
      }

      setInputAutoFocus()
    } catch (e) {
      tratamentoErroPadrao(e)
    } finally {
      setTimeout(() => processando.current = false, 1000)
      globalMU.unblockUI()
    }
  })

  const onPesquisarProdutoComAgregado = useStableCallback(async (item: IProduto, dadosPesquisa?: PagedMessageResponse<IProduto>, ordem?: string) => {
    if (!isMounted.current) return
    const orcamento = orcamentoRef.current
    const dadosPesquisaItens = dadosPesquisaItensRef.current
    const dadosPesquisaItensAux = dadosPesquisa ?? dadosPesquisaItens
    try {

      if (item?.subProdutoAgregadoCarregado) {
        return
      }

      globalMU.blockUI()

      const produtos = await microuniversoApi.Produto.pesquisar({
        CodigoProdutoComAgregado: item.Codigo,
        identificadorOrcamento: orcamento.IdentificadorOrcamento,
        Ordem: ordem,
        NumeroPagina: 1,
        TamanhoPagina: 1000
      });
      if (!isMounted.current) return
      const itemAlterado = { ...item, subProdutoAgregadoAberto: true, subProdutoAgregadoCarregado: true }
      let indexArray = (dadosPesquisaItensAux?.Entities ?? []).indexOf(item)
      setDadosPesquisaItens({
        ...dadosPesquisaItensAux, Entities: (dadosPesquisaItensAux?.Entities ?? []).slice(0, indexArray).concat(itemAlterado)
          .concat(produtos).concat((dadosPesquisaItensAux?.Entities ?? []).slice(indexArray + 1, dadosPesquisaItensAux?.Entities?.length))
      })
      globalMU.unblockUI();
    } catch (e) {
      tratamentoErroPadrao(e)
    }
  })

  const onPesquisarProdutoAgregadoSugerido = useStableCallback(async (item: IProduto, dadosPesquisa?: PagedMessageResponse<IProduto>, ordem?: string) => {
    if (!isMounted.current) return
    const orcamento = orcamentoRef.current
    const dadosPesquisaItens = dadosPesquisaItensRef.current
    const dadosPesquisaItensAux = dadosPesquisa ?? dadosPesquisaItens
    try {

      if (item?.subProdutoAgregadoSugeridoCarregado) {
        return
      }

      globalMU.blockUI()
      const produtos = await microuniversoApi.Produto.pesquisar({
        CodigoProdutoComAgregadoSugerido: item.Codigo,
        identificadorOrcamento: orcamento.IdentificadorOrcamento,
        Ordem: ordem,
        NumeroPagina: 1,
        TamanhoPagina: 1000
      });
      if (!isMounted.current) return
      const itemAlterado = { ...item, subProdutoAgregadoSugeridoAberto: true, subProdutoAgregadoSugeridoCarregado: true }
      let indexArray = (dadosPesquisaItensAux?.Entities ?? []).indexOf(item)
      setDadosPesquisaItens({
        ...dadosPesquisaItensAux, Entities: (dadosPesquisaItensAux?.Entities ?? []).slice(0, indexArray).concat(itemAlterado)
          .concat(produtos).concat((dadosPesquisaItensAux?.Entities ?? []).slice(indexArray + 2, dadosPesquisaItensAux?.Entities?.length))
      })
      globalMU.unblockUI();
    } catch (e) {
      tratamentoErroPadrao(e)
    }
  })

  const onProdutoRepetido = useStableCallback((produtoRepetido: ProdutoRepetido) => {
    if (!isMounted.current) return

    const dadosPesquisaItens = dadosPesquisaItensRef.current
    const itensSelecionados = itensSelecionadosRef.current

    const values = Object.entries(produtoRepetido);
    const data = { codigo: values[0][0], acao: values[0][1] }

    const item = (dadosPesquisaItens?.Entities ?? []).find((produto) => produto.Codigo == data.codigo)
    let indexArray = (dadosPesquisaItens?.Entities ?? []).indexOf(item)
    let itemAlterado = { ...item, AcaoProdutoRepetido: data.acao == "incrementar" ? 1 : 0 }
    setDadosPesquisaItens({
      ...dadosPesquisaItens, Entities: (dadosPesquisaItens?.Entities ?? []).slice(0, indexArray).concat(itemAlterado)
        .concat((dadosPesquisaItens?.Entities ?? []).slice(indexArray + 1, dadosPesquisaItens?.Entities?.length))
    })
    let itensAlteradosSelecionados = itensSelecionados.map((itemA) => itemA.Codigo == item.Codigo ? itemAlterado : itemA)
    setItensSelecionados(itensAlteradosSelecionados)

    // 491123 — mantém em sincronia a cópia do produto na cesta (redux), caso ele já tenha sido
    // adicionado antes de escolher a ação de repetido na pesquisa; no-op se o produto não estiver
    // na cesta (reducer só atualiza por Codigo, ver APRENDIZADOS #179)
    dispatch(atualizarAcaoProdutoRepetidoSelecionadoAction({ codigo: data.codigo, acao: itemAlterado.AcaoProdutoRepetido }))
  })

  const onAdicionarItensGrid = useStableCallback(async (continuarNaTelaPesquisa: boolean, itens: IProduto[] = itensSelecionadosRef.current, onSucesso?: () => void, mensagemProcessamento?: string) => {

      
    if (!isMounted.current) return false
    try {
      const props = propsRef.current
      const orcamento = orcamentoRef.current
      globalMU.blockUI()
      globalMU.blockScreen({ message: mensagemProcessamento })
      setProcessandoProduto(true)
      if (processando.current) return false
      processando.current = true

      let mensagensErro = ""
      itens.length === 0 ? mensagensErro += "Por favor, selecione os produtos a serem adicionados.<br/><br/>" : {}
      itens.filter((produtos) => produtos.DescricaoDisponibilidade === "Bota-Fora").length > 0 ? mensagensErro += "Produto bota-fora só pode ser vendido pelo Checkout e ECF sem orçamento.<br/><br/>" : {}
      itens.filter((produtos) => produtos.DescricaoDisponibilidade === "Não disponível para venda").length > 0 ? mensagensErro += "Produto não disponível para venda não pode ser vendido.<br/><br/>" : {}

    
      let mensagensAviso = ""
      itens.filter((produtos) => !produtos.BaseTintometricoSimplificado && produtos.TipoComponente === "P" && !produtos.CorTinta).length > 0 ? mensagensAviso += "Para inserir o(s) produto(s) Tinta é necessária seleção da cor.<br/><br/>" : {}
      itens.filter((produtos) => produtos.Repetido && produtos.AcaoProdutoRepetido == null).length > 0 ? mensagensAviso += "Para inserir o(s) produto(s) é necessário selecionar a ação para o(s) produto(s) repetido(s).<br/><br/><b>Dica</b>: use o botão [<b><u>AÇÕES</u></b>] ou veja o icone [<b><u>+1</u></b>] na última coluna do grid" : {}
      itens.filter((produtos) => produtos.BaseTintometricoSimplificado && !produtos.CorTinta).length > 0 ? mensagensAviso += "Para inserir o(s) produto(s) Tinta é necessária seleção da cor.<br/><br/>" : {} // PA 402355 repasse 311033

      if (mensagensErro != "") {
        globalMU.showErrorMessage(mensagensErro);
        //return;
      }

      if (mensagensAviso != "") {
        globalMU.showWarnMessage(mensagensAviso);
      }
      if (mensagensErro != "" || mensagensAviso != "") {
        return false;
      }

      if (props.adicionarProdutos) {
        props.adicionarProdutos(itens)
        
        onSucesso?.()
        return true
      }

      const resultadoAdicionarItens = await adicionarItens(orcamento.IdentificadorOrcamento, itens)
      if (!isMounted.current) return false
      // 491123 — adicionarItens já mostra o toast de erro (via globalMU.tratarRetorno) quando o
      // servidor rejeita algum item (ex: componente de tinta "não disponível para venda"), mas até
      // aqui o status retornado era ignorado: o fluxo seguia como se tivesse dado certo, limpando a
      // cesta e disparando a mensagem "N produto(s) foram adicionados ao orçamento." mesmo sem ter
      // adicionado nada.
      if (resultadoAdicionarItens.status !== "SUCESSO") return false

      // Pré-venda: só depois do orçamento ter recebido os itens de verdade — avisa a Fenix quais
      // pré-vendas foram convertidas (ela usa o id pra não oferecer a mesma pré-venda de novo numa
      // busca futura). Cancelar/fechar o modal antes deste ponto não deve consumir a pré-venda —
      // por isso não entra antes do `if` de sucesso acima.
      if (props.preVendaSelecionada?.length > 0) {
        try {
          await microuniversoApi.Orcamento.definirPreVendas(orcamento.IdentificadorOrcamento, props.preVendaSelecionada.map(p => p.Id))
        } catch (e) {
          tratamentoErroPadrao(e)
        }
      }

      onSucesso?.()

      const orcamentoAtualizado = store.getState().orcamento

      const existemProdutosMadeiraNaoConfigurados = (orcamentoAtualizado.ItensOrcamento ?? []).some(i => i.Madeira && i.DadosMadeira == null)
      if (existemProdutosMadeiraNaoConfigurados) {
        // 491123 — configurar o tratamento de madeira exige interação do usuário, então esta
        // instância precisa surgir em tela cheia mesmo se foi montada no host oculto do botão
        // flutuante da cesta (ver prepararSubFluxoTelaCheia). Em uso normal (já em 'conteudo-pagina'),
        // isto é um no-op.
        const subFluxo = prepararSubFluxoTelaCheia(() => renderizarComponentReact(<ItensOrcamentoContainer />, "conteudo-pagina", true))
        if (!subFluxo) return false

        renderizarComponentReact(
          <TratamentoMadeiraContainer
            somenteLeitura={orcamento == null || orcamento.SomenteLeitura}
            onFinalizarConfiguracaoProdutos={() => {
              if (continuarNaTelaPesquisa) {

                renderizarComponentReact(
                  <PaginaPesquisaProdutoContainer {...props} regiaoRenderizada={subFluxo.regiaoRenderizada}
                  />, subFluxo.regiaoRenderizada, true
                )
              } else {
                subFluxo.onVoltarTelaCheia()
              }
            }}
            onCancelar={() => {
              if (continuarNaTelaPesquisa) {

                renderizarComponentReact(
                  <PaginaPesquisaProdutoContainer {...props} regiaoRenderizada={subFluxo.regiaoRenderizada}
                  />, subFluxo.regiaoRenderizada, true
                )
              } else {
                subFluxo.onVoltarTelaCheia()
              }
            }}
          />, subFluxo.regiaoRenderizada, true
        )
      } else if (continuarNaTelaPesquisa) {

        setFiltros(filtroPadrao)
        setDadosPesquisaItens({})
      } else {
        onVoltar()
      }

      return true

    } catch (e) {

      tratamentoErroPadrao(e)
      return false
    } finally {
      if (isMounted.current && continuarNaTelaPesquisa) {
        setItensSelecionados([]) // 465686
      }
      setTimeout(() => processando.current = false, 1000)
      globalMU.unblockUI()
      globalMU.unblockScreen()
      if (isMounted.current) {
        setProcessandoProduto(false)
      }
    }
  })

  const onInserirNovo = useStableCallback(async () => {
    const dadosPesquisaItens = dadosPesquisaItensRef.current
    const itensSelecionados = itensSelecionadosRef.current
    let itensAlterados = (dadosPesquisaItens?.Entities ?? []).map(item => {
      if (item.Repetido && itensSelecionados.find(x => x.Codigo === item.Codigo)?.Codigo !== undefined) {
        item.AcaoProdutoRepetido = 0
      }
      return item
    })
    setDadosPesquisaItens({ ...dadosPesquisaItens, Entities: itensAlterados })

    let itensAlteradosSelecionados = itensSelecionados.map((item) => ({ ...item, AcaoProdutoRepetido: item.Repetido ? 0 : item.Repetido }))

    setItensSelecionados(itensAlteradosSelecionados)
  })

  const onIncrementarQuantidade = useStableCallback(async () => {
    const dadosPesquisaItens = dadosPesquisaItensRef.current
    const itensSelecionados = itensSelecionadosRef.current
    let itensAlterados = (dadosPesquisaItens?.Entities ?? []).map(item => {
      if (item.Repetido && itensSelecionados.find(x => x.Codigo === item.Codigo)?.Codigo !== undefined) {
        item.AcaoProdutoRepetido = 1
      }
      return item
    })
    setDadosPesquisaItens({ ...dadosPesquisaItens, Entities: itensAlterados })

    let itensAlteradosSelecionados = itensSelecionados.map((item) => ({ ...item, AcaoProdutoRepetido: item.Repetido ? 1 : item.Repetido }))
    setItensSelecionados(itensAlteradosSelecionados)
  })


  // 491123 — alterar a quantidade pelo stepper (+/-/input) da coluna de seleção rápida não deve
  // selecionar nem deselecionar a linha (itensSelecionados); seleção só ocorre ao clicar em outra
  // coluna da mesma linha (props.onProdutoSelecionado). Mantém apenas a atualização de
  // dadosPesquisaItens, para que item.Quantidade fique correto ao adicionar à cesta.
  const onAlteracaoQuantidade = useStableCallback(async (produtoSelecionado: IProduto, quantidade: number) => {
    const dadosPesquisaItens = dadosPesquisaItensRef.current

    // 491123 — guarda a quantidade informada para sobreviver à troca de página (ver
    // quantidadesInformadasRef na declaração e a restauração em pesquisaPaginada). Registrar aqui,
    // e não no componente da linha, porque o container é o único que sobrevive à paginação.
    if (produtoSelecionado?.Codigo != null) {
      quantidadesInformadasRef.current[produtoSelecionado.Codigo] = quantidade
    }

    const itemGridPesquisaItens = (dadosPesquisaItens?.Entities ?? []).find((produto) => produto == produtoSelecionado)
    let posicaoItemGridPesquisaItens = (dadosPesquisaItens?.Entities ?? []).indexOf(itemGridPesquisaItens)
    let itemGridAlterado = { ...itemGridPesquisaItens, Quantidade: quantidade }
    setDadosPesquisaItens({
      ...dadosPesquisaItens, Entities: (dadosPesquisaItens?.Entities ?? []).slice(0, posicaoItemGridPesquisaItens).concat(itemGridAlterado)
        .concat((dadosPesquisaItens?.Entities ?? []).slice(posicaoItemGridPesquisaItens + 1, dadosPesquisaItens?.Entities?.length))
    })

    // 491123 — itensSelecionados guarda REFERÊNCIAS aos objetos de Entities. A linha acima troca a
    // entidade por uma CÓPIA com a nova Quantidade, então o objeto que ficou em itensSelecionados
    // continua com a quantidade antiga — e é dele que "Adicionar" (onAdicionarProdutosSelecionados)
    // monta a cesta, fazendo a quantidade digitada no stepper nunca chegar em
    // TabelaProdutosSelecionados_ProdutoSelecionado_InputQuantidade_. Reflete a mudança aqui também.
    //
    // Updater FUNCIONAL de propósito: no mesmo evento, onAlteraQuantidade (ItemPesquisaProduto) já
    // chamou props.onProdutoSelecionado() -> onToggleProdutoSelecionado -> setItensSelecionados(
    // concat(item)) e o React ainda não re-renderizou. Ou seja, itensSelecionadosRef.current ainda
    // NÃO tem a linha recém-selecionada; ler a ref aqui descartaria a seleção que acabou de ocorrer.
    setItensSelecionados((itensAtuais) =>
      itensAtuais.map((item) =>
        item.CodigoProduto == produtoSelecionado?.CodigoProduto
          ? { ...item, Quantidade: quantidade }
          : item
      )
    )
  })

  const obterMarkupProdutosJaPesquisados = useStableCallback(async (produtos: PagedMessageResponse<IProduto>) => {
    if (produtos?.Entities?.length > 0 && produtos?.Entities[0].MarkupCalculado == null && valorParametro("VISUALIZA_MARKUP_PRODUTO_ORCAMENTO") === "S") {
      let listaCodpro = ""
      listaCodpro += produtos?.Entities?.map((item) => { return item.Codigo })
      const markup = await microuniversoApi.Produto.obterMarkupPesquisaProdutos(listaCodpro, orcamentoRef.current.IdentificadorOrcamento);
      if (!isMounted.current) return;

      const entitiesComMarkup = (produtos?.Entities ?? []).map((item, i) => ({ ...item, MarkupCalculado: markup[i].MarkupCalculado }))
      setDadosPesquisaItens({ ...produtos, Entities: entitiesComMarkup });
    }
  })

  const funcaoRetornaPagina = useStableCallback(() => {
    const props = propsRef.current
    
    props.regiaoRenderizada != "conteudo-pagina" && $("[container]").show()
    removerComponenteReact("conteudo-pagina")

    renderizarComponentReact(<PaginaPesquisaProdutoContainer
      {...props}
      filtroPesquisaAnterior={props.filtroPesquisaAnterior}
      dadosGridPesquisaItens={dadosPesquisaItensRef.current}
      filtroAnterior={filtrosRef.current}
      passos={passosInterno.current}
      onVoltar={onVoltar}
      itensSelecionados={itensSelecionadosRef.current} />,
      props.regiaoRenderizada,
      true
    )
  })


  const passosInterno = useRef<Dict<string, () => void>>(props.passos ? new Dict(Object.assign({}, props.passos.map)) : new Dict())

  // 491123 — desabilitado só quando montado no host oculto do botão flutuante da cesta:
  // "menu-consulta-produtos-react" é uma região fixa e visível do layout principal, e não deve ser
  // tocada por uma instância que está rodando escondida em segundo plano.
  //
  // A condição é a NEGAÇÃO do host oculto, e não `=== "conteudo-pagina"`: esta página também roda
  // VISÍVEL em "pesquisa-produtos-region" (tela Pesquisar Produtos fora do orçamento,
  // Views\Produto\Pesquisar.cshtml), que tem os mesmos <div id="menu-consulta-produtos-react"> e
  // <div id="conteudo-pagina"> do orçamento. Com o teste antigo, selecionar uma linha da grid lá
  // nunca abria o menu lateral de consultas — só funcionava dentro do orçamento.
  useMenuConsultaProduto(passosInterno.current, funcaoRetornaPagina, itensSelecionados.length == 1 ? itensSelecionados[0] : null, props.foraOrcamento, props.regiaoRenderizada !== REGIAO_HOST_OCULTO_CESTA_PRODUTOS)

  const onVoltar = useStableCallback(() => {
    propsRef.current.onVoltar()
  })

  // 491123 — sub-fluxos que exigem tela própria (cor de tinta, configuração de madeira) não podem
  // ficar escondidos no host oculto do botão flutuante da cesta (ver _BaseInterno.cshtml): o usuário
  // precisa efetivamente ver e interagir com eles. Quando esta instância não está em 'conteudo-pagina',
  // esta função confirma o descarte da tela atual, se autodesmonta do host oculto (que deixa de fazer
  // sentido existir) e retorna a região correta para o sub-fluxo "surgir" em tela cheia — junto com o
  // onVoltar apropriado: `onVoltarSeNaoSurgir` (o comportamento de cada chamador, inalterado) quando
  // esta instância já estava visível em 'conteudo-pagina', ou "ir para Itens" quando precisou surgir
  // (não há mais host oculto para o qual voltar). Retorna null se o usuário optou por não descartar a
  // tela atual (o chamador deve abortar a ação nesse caso).
  const prepararSubFluxoTelaCheia = useStableCallback((onVoltarSeNaoSurgir: () => void): { regiaoRenderizada: string, onVoltarTelaCheia: () => void } | null => {
    const props = propsRef.current

    if (props.regiaoRenderizada === "conteudo-pagina") {
      return { regiaoRenderizada: props.regiaoRenderizada, onVoltarTelaCheia: onVoltarSeNaoSurgir }
    }

    if (window.orcamentoController && typeof window.orcamentoController.podeDescartarAlteracoesTelaAtual === 'function' && !window.orcamentoController.podeDescartarAlteracoesTelaAtual()) {
      return null
    }

    removerComponenteReact(props.regiaoRenderizada)

    // itemMenuSelecionado (orcamentoController.tsx) normalmente marca o item do menu lateral
    // clicado como "ativo" — como este surgimento bypassa esse fluxo, replica a marcação
    // manualmente (window.ativarItemMenuLateral, exposto em _BaseInterno.cshtml), senão o item
    // da aba anterior (ex: Entrega) continua "ativo" mesmo mostrando a pesquisa de produtos.
    window.ativarItemMenuLateral && window.ativarItemMenuLateral('item-venda')

    return {
      regiaoRenderizada: "conteudo-pagina",
      onVoltarTelaCheia: () => renderizarComponentReact(<ItensOrcamentoContainer />, "conteudo-pagina", true)
    }
  })

  const onPassoSelecionado = useStableCallback((passo: string) => {
    passosInterno.current.get(passo)()
  })

  useEffect(() => {
    globalMU.blockUI()
    const executarFuncoes = async () => {
      await Promise.all([
        atualizarValoresParametros(),
        obterDadosIniciaisGrid(),
        atualizarExibicaoEstoques(),
        atualizarExibicaoTextoTecnico(),
        atualizarExibicaoBotaoProdutosForaDoEstoque(),
        mascaraClasseProduto(),
        atualizarPermiteEngrenagemGrid(),
        atualizarPermissaoIncluirOrcamento(),
        obterDisponibilidades(),
        obterListarSistemaTintometrico(),
      ])
    }


    executarFuncoes()
    // Se o modal da cesta já nasce aberto (491123 — botão flutuante fora da tela de pesquisa),
    // o foco deve ficar no Dialog, não no campo de busca por trás dele: focar aqui rouba o foco
    // do MUI no mesmo ciclo em que ele marca o restante da árvore com aria-hidden, disparando
    // "Blocked aria-hidden on an element because its descendant retained focus".
    if (!modalCestaProdutosAberto) setInputAutoFocus();
    if (props.filtroPesquisaAnterior) pesquisaAnterior(props.filtroPesquisaAnterior)
    if (props.dadosGridPesquisaItens) onPesquisaAposCorSelecionada()
    if (props.preVendaSelecionada) pesquisaPreVenda(props.preVendaSelecionada)
  }, []);

  useEffect(() => {
    if (parametros != null && parametros.length > 0
      && colunas != null && colunas.length >= 0
      && listaDisponibilidade != null && listaDisponibilidade.length > 0
      && listaSistemaTintometrico != null && listaSistemaTintometrico.length > 0
      && permiteEngrenagemGrid != null
      && exibirFiltroEstoqueDisponivel != null
      && exibirFiltroEstoqueDisponivelOutrasFiliais != null
      && exibirTextoTecnico != null
      && mascara != null) {
      setParametrosCarregados(true)
      globalMU.unblockUI()
    }

  }, [parametros, colunas, listaDisponibilidade, listaSistemaTintometrico, permiteEngrenagemGrid, exibirFiltroEstoqueDisponivel, exibirFiltroEstoqueDisponivelOutrasFiliais, exibirTextoTecnico, mascara])

  // 491123 — só agora a grade (GridItensPesquisaProdutos) de fato existe no DOM: antes de
  // parametrosCarregados virar true a tela renderiza só "Carregando... Aguarde!" (ver render mais
  // abaixo), então tentar o scroll em onPesquisaAposCorSelecionada (chamado ainda no useEffect de
  // montagem, antes desses parametros carregarem) sempre encontrava a linha ausente e não fazia nada.
  useEffect(() => {
    if (!parametrosCarregados) return
    const codigoProdutoConfigurado = produtoConfiguradoParaScrollRef.current
    if (!codigoProdutoConfigurado) return
    produtoConfiguradoParaScrollRef.current = null
    document
      .getElementById(`ItemPesquisaProduto_LinhaTabela_${codigoProdutoConfigurado}`)
      ?.scrollIntoView({ behavior: "smooth", block: "center" })
  }, [parametrosCarregados])

  useEffect(() => () => {
    isMounted.current = false
  }, [])

  useEffect(() => {
    props.foraOrcamento && passosInterno.current.set("Produto", funcaoRetornaPagina)
    !props.foraOrcamento && passosInterno.current.set("Pesquisar Produtos", funcaoRetornaPagina)
  }, [])

  // handlers estabilizados (useStableCallback) para nao invalidar o value do PaginaPesquisaProdutoContext a cada render (APRENDIZADOS #164/#166)
  const usuarioLogado = useMemo(() => globalMU.sessionStorage.getData("UsuarioLogado"), [])

  const onPesquisaPreVenda = useStableCallback(() => {
    const props = propsRef.current
    renderizarComponentReact(
      <PesquisaPreVendaContainer
        key="PaginaPesquisaProdutoContainer_PesquisaPreVendaContainer"
        orcamentoForaModuloVendas={props.foraOrcamento}
        regiaoRenderizada={props.regiaoRenderizada}
        onVoltar={funcaoRetornaPagina}
        passos={passosInterno.current}
      />,
      props.regiaoRenderizada,
      true
    );
  })

  const onPesquisasAnteriores = useStableCallback(() => {
    const props = propsRef.current
    renderizarComponentReact(
      <PesquisasAnterioresContainer
        key="PaginaPesquisaProdutoContainer_PesquisasAnterioresContainer"
        orcamentoForaModuloVendas={props.foraOrcamento}
        regiaoRenderizada={props.regiaoRenderizada}
        onVoltar={funcaoRetornaPagina}
        passos={passosInterno.current}
      />,
      props.regiaoRenderizada,
      true
    );
  })

  const onPesquisarCores = useStableCallback(() => {
    const props = propsRef.current
    renderizarComponentReact(
      <PesquisaCorTintometricoContainer
        key="PaginaPesquisaProdutoContainer_PesquisaCorTintometricoContainer"
        orcamentoForaModuloVendas={props.foraOrcamento}
        regiaoRenderizada={props.regiaoRenderizada}
        onVoltar={funcaoRetornaPagina}
        onAdicionadoComSucesso={props.onVoltar}
        passos={passosInterno.current} />,
      props.regiaoRenderizada,
      true
    );
  })

  const onPesquisaClasse = useStableCallback(() => {
    const props = propsRef.current
    renderizarComponentReact(
      <PesquisaClasseContainer
        onSelecionadoClasse={(codigoClasse) =>
          renderizarComponentReact(<PaginaPesquisaProdutoContainer {...props}
            dadosGridPesquisaItens={dadosPesquisaItensRef.current} itensSelecionados={itensSelecionadosRef.current}
            filtroAnterior={{ ...filtrosRef.current, Classe: codigoClasse }} />, props.regiaoRenderizada, true)
        }
        regiaoRenderizada={props.regiaoRenderizada}
        onVoltar={funcaoRetornaPagina}
        key="PaginaPesquisaProdutoContainer_PesquisaClasseContainer"
        passos={passosInterno.current} />
      ,
      props.regiaoRenderizada,
      true
    );
  })

  const onExcluirClasse = useStableCallback(() => setFiltros(prev => ({
    ...prev,
    Classe: "",
    ClasseProduto: "",
  })))

  const onPesquisaFornecedor = useStableCallback(() => {
    const props = propsRef.current
    renderizarComponentReact(
      <PesquisaFornecedorContainer
        key="PaginaPesquisaProdutoContainer_PesquisaFornecedorContainer"
        onSelecionadoFornecedor={(codigoFornecedor, nomeFornecedor) =>
          renderizarComponentReact(<PaginaPesquisaProdutoContainer {...props}
            filtroAnterior={{ ...filtrosRef.current, Fornecedor: codigoFornecedor, NomeFornecedor: nomeFornecedor }}
            dadosGridPesquisaItens={dadosPesquisaItensRef.current}
            itensSelecionados={itensSelecionadosRef.current} />, props.regiaoRenderizada, true)
        }
        regiaoRenderizada={props.regiaoRenderizada}
        onVoltar={funcaoRetornaPagina}
        passos={passosInterno.current} />,
      props.regiaoRenderizada,
      true
    );
  })

  const onExcluirFornecedor = useStableCallback(() =>
    setFiltros(prev => ({
      ...prev,
      Fornecedor: "",
      NomeFornecedor: "",
    }))
  )

  const onCodigoModificado = useStableCallback((Codigo: string) => {
    setFiltros(prev => ({ ...prev, Codigo }));
  })

  const onReferenciaModificado = useStableCallback((Referencia: string) => {
    setFiltros(prev => ({ ...prev, Referencia }));
  })

  const onDescricaoModificado = useStableCallback((Descricao: string) => {
    setFiltros(prev => ({ ...prev, Descricao }));
  })

  const onClasseModificado = useStableCallback((Classe: string) => {
    setFiltros(prev => ({
      ...prev,
      Classe: Classe.replace(/_/g, '').replace(/-/g, '').replace(/\//g, '').replace(/\./g, ''),
    }));
  })

  const onEstoqueDisponivelFilialCorrente = useStableCallback((EstoqueDisponivelFilialCorrente: boolean) => {
    const atual = filtrosRef.current
    const outrosMarcados = atual.EstoqueDisponivelCD || atual.EstoqueDisponivelOutrasFiliais
    setFiltrouAlgumCheckboxEstoquesDisponivel(EstoqueDisponivelFilialCorrente || outrosMarcados) // esse aqui é o parametro //435588
    setFiltros(!EstoqueDisponivelFilialCorrente && !outrosMarcados
      ? { ...atual, EstoqueDisponivelFilialCorrente, TipoFiltroEstoque: "", ConsiderarEstoqueDisponivelLote: false, QuantidadeInicialFiltroEstoque: 0, QuantidadeFinalFiltroEstoque: 0 }
      : { ...atual, EstoqueDisponivelFilialCorrente })
  })

  const onEstoqueDisponivelOutrasFiliais = useStableCallback((EstoqueDisponivelOutrasFiliais: boolean) => {
    const atual = filtrosRef.current
    const outrosMarcados = atual.EstoqueDisponivelCD || atual.EstoqueDisponivelFilialCorrente
    setFiltrouAlgumCheckboxEstoquesDisponivel(EstoqueDisponivelOutrasFiliais || outrosMarcados) // esse aqui é o parametro //435588
    setFiltros(!EstoqueDisponivelOutrasFiliais && !outrosMarcados
      ? { ...atual, EstoqueDisponivelOutrasFiliais, TipoFiltroEstoque: "", ConsiderarEstoqueDisponivelLote: false, QuantidadeInicialFiltroEstoque: 0, QuantidadeFinalFiltroEstoque: 0 }
      : { ...atual, EstoqueDisponivelOutrasFiliais })
  })

  const onEstoqueDisponivelCD = useStableCallback((EstoqueDisponivelCD: boolean) => { // 435588
    const atual = filtrosRef.current
    const outrosMarcados = atual.EstoqueDisponivelFilialCorrente || atual.EstoqueDisponivelOutrasFiliais
    setFiltrouAlgumCheckboxEstoquesDisponivel(EstoqueDisponivelCD || outrosMarcados)
    setFiltros(!EstoqueDisponivelCD && !outrosMarcados
      ? { ...atual, EstoqueDisponivelCD, TipoFiltroEstoque: "", ConsiderarEstoqueDisponivelLote: false, QuantidadeInicialFiltroEstoque: 0, QuantidadeFinalFiltroEstoque: 0 }
      : { ...atual, EstoqueDisponivelCD })
  })

  const onOrdemModificado = useStableCallback((Ordem: string) => {
    setFiltros(prev => ({ ...prev, Ordem }));
  })

  const onCodigoFabricanteModificado = useStableCallback((CodigoFabricante: string) => {
    setFiltros(prev => ({ ...prev, CodigoFabricante }));
  })

  const onCodigoSistemaTintometricoModificado = useStableCallback((sistemaTintometricoOid: number) => {
    setFiltros(prev => ({ ...prev, SistemaTintometrico: sistemaTintometricoOid }));
  })

  const onTextoTecnicoModificada = useStableCallback((TextoTecnico: string) => {
    setFiltros(prev => ({ ...prev, TextoTecnico }));
  })

  const onModeloModificado = useStableCallback((ModeloProduto: string) => {
    setFiltros(prev => ({ ...prev, ModeloProduto }));
  })

  const onDisponibilidadesModificadas = useStableCallback((Disponibilidade: string[]) => {
    setFiltros(prev => ({ ...prev, Disponibilidade }));
  })

  const onProdutoEmTransitoModificado = useStableCallback((ProdutoEmTransito: boolean) => {
    setFiltros(prev => ({ ...prev, ProdutoEmTransito }));
  })

  const onApenasProdutoFinalModificado = useStableCallback((ProdutoFinal: string) => {
    setFiltros(prev => ({ ...prev, ProdutoFinal }));
  })

  const onApenasFabricacaoPropriaModificado = useStableCallback((ApenasFabricacaoPropria: boolean) => {
    setFiltros(prev => ({ ...prev, ApenasFabricacaoPropria }))
  })

  const onProdutoOfertaModificado = useStableCallback((ApenasProdutoOferta: boolean) => {
    setFiltros(prev => ({ ...prev, ProdutoOferta: ApenasProdutoOferta }));
  })

  const onConsiderarEstoqueDisponivelLote = useStableCallback((considerarEstoqueDisponivelLote: boolean) => { setFiltros(prev => ({ ...prev, ConsiderarEstoqueDisponivelLote: considerarEstoqueDisponivelLote })) }) //435588
  const onTipoFiltroEstoqueModificado = useStableCallback((tipoFiltroEstoque: string) => { setFiltros(prev => ({ ...prev, TipoFiltroEstoque: tipoFiltroEstoque })) }) //435588
  const onQuantidadeInicialFiltroEstoqueModificado = useStableCallback((quantidade: number) => { setFiltros(prev => ({ ...prev, QuantidadeInicialFiltroEstoque: quantidade })) }) //435588
  const onQuantidadeFinalFiltroEstoqueModificado = useStableCallback((quantidade: number) => { setFiltros(prev => ({ ...prev, QuantidadeFinalFiltroEstoque: quantidade })) }) //435588

  const onMarkupInicialModificado = useStableCallback((MarkupInicial: string) => {
    setFiltros(prev => ({ ...prev, MarkupInicial }))
  })

  const onMarkupFinalModificado = useStableCallback((MarkupFinal: string) => {
    setFiltros(prev => ({ ...prev, MarkupFinal }))
  })

  const onAlterarFonte = useStableCallback((fonte: number) => {
    alterarFonte(fonte);
    setTamanhoFonte(fonte);
  })

  const onMostrarTinta = useStableCallback((item: IProduto) => {
    const props = propsRef.current
    const subFluxo = prepararSubFluxoTelaCheia(onVoltar)
    if (!subFluxo) return

    renderizarComponentReact(
      <PesquisaCorContainer
        key="PaginaPesquisaProdutoContainer_PesquisaCorContainer"
        adicionarProdutos={props.adicionarProdutos}
        onVoltarPesquisaProdutos={subFluxo.onVoltarTelaCheia}
        fitroAnterior={filtrosRef.current}
        dadosGridPesquisaItens={dadosPesquisaItensRef.current}
        item={item}
        onVoltar={funcaoRetornaPagina}
        passos={passosInterno.current}
        itensSelecionados={itensSelecionadosRef.current}
        regiaoRenderizada={subFluxo.regiaoRenderizada}
      />,
      subFluxo.regiaoRenderizada,
      true
    )
  })

  const onComparar = useStableCallback(() => {
    const props = propsRef.current
    renderizarComponentReact(
      <CompararProdutosContainer
        key="PaginaPesquisaProdutoContainer_CompararProdutosContainer"
        regiaoRenderizada={props.regiaoRenderizada}
        onVoltar={funcaoRetornaPagina}
        passos={passosInterno.current}
        itens={itensSelecionadosRef.current} />,
      props.regiaoRenderizada,
      true
    )
  })

  const onOk = useStableCallback((item?: IProduto) => onAdicionarItensGrid(false, item ? [item] : undefined))

  const onInserirContinuar = useStableCallback(() => { onAdicionarItensGrid(true), setInputAutoFocus() })

  const onMostrarImagens = useStableCallback((identificadorItem: string, classeElementoAncora: string) => {
    // busca também na cesta de produtos selecionados: o produto pode não estar mais nos
    // resultados da pesquisa atual (usuário pesquisou outra coisa depois de adicionar à cesta)
    const item = (dadosPesquisaItensRef.current?.Entities ?? []).find(i => i.Codigo == identificadorItem)
      ?? produtosSelecionadosRef.current?.find(i => i.Codigo == identificadorItem)

    $("." + classeElementoAncora).lightGallery({
      dynamic: true,
      dynamicEl: (item?.Imagens ?? []).map(i => ({
        subHtml: i.Nome,
        src: i.Caminho,
        thumb: i.Caminho
      }))

    });
  })

  const onPesquisarProdutosForaEstoque = useStableCallback(() => {
    const props = propsRef.current
    const orcamento = orcamentoRef.current
    if (orcamento.Situacao !== null && orcamento.Situacao !== 6) {
      globalMU.showErrorMessage("Situação do orçamento deve não permite adicionar produtos fora do estoque.")
      return
    }
    renderizarComponentReact(
      <ProdutosForaEstoqueContainer
        key="PaginaPesquisaProdutoContainer_ProdutosForaEstoqueContainer"
        orcamentoForaModuloVendas={props.foraOrcamento}
        regiaoRenderizada={props.regiaoRenderizada}
        onVoltar={funcaoRetornaPagina}
        passos={passosInterno.current}
      />,
      props.regiaoRenderizada,
      true
    )
  })

  const paginaPesquisaProdutoContextValue = useMemo<PaginaPesquisaProdutoContextType>(() => ({
    inputAutofocusRef: inputAutofocusRef,
    autoFocusReferencia: chaveMovimentacaoEhReferencia,
    desabilitarPesquisarHistorico: !props.desabilitarPesquisarHistorico,
    processandoProduto: processandoProduto,
    chamadoParaInserirProdutoNoOrcamento: props.chamadoParaInserirProdutoNoOrcamento, // 491123
    modalCestaProdutosAberto: modalCestaProdutosAberto,
    onFecharModalCestaProdutos: onFecharModalCestaProdutos,
    pesquisandoApenasParaFiltroProdutosLupa: props.pesquisandoApenasParaFiltroProdutosLupa, // 470698
    ocultarSubPaginas: props.ocultarSubPaginas,
    habiliarAcoesGrid: !orcamento.SomenteLeitura && !props.foraOrcamento,
    exibirLocalFisico: valorParametro("APRESENTAR_LOCAL_FISICO_CONSULTA_PRODUTO") == "S" || valorParametro("EXIBE_LOCAL_FISICO_CONSULTA_PRODUTOS") == "S",
    filtrouAlgumCheckboxEstoquesDisponivel: filtrouAlgumCheckboxEstoquesDisponivel, // 435588
    parametroControleLote: valorParametro("CONTROLE_LOTE_TONALIDADE") == "S", //435588
    pesquisandoNoOrcamentoVenda: !props.foraOrcamento,
    onToggleProdutoSelecionado: onToggleProdutoSelecionado,
    onPesquisaPreVenda: onPesquisaPreVenda,
    onPesquisasAnteriores: onPesquisasAnteriores,
    onPesquisarCores: onPesquisarCores,
    markupProdutoOrcamento:
      valorParametro("VISUALIZA_MARKUP_PRODUTO_ORCAMENTO") == "S"
    ,
    exibirCampoFiltroEstoqueDisponivel: exibirFiltroEstoqueDisponivel,
    exibirCampoPesquisaEstoqueOutrasFiliais:
      valorParametro("EXIBIR_ESTOQUE_OUTRAS_FILIAIS") == "S" && exibirFiltroEstoqueDisponivelOutrasFiliais
    ,
    exibirMensagemParametroEstoqueOutrasFiliais:
      valorParametro("EXIBIR_ESTOQUE_OUTRAS_FILIAIS") != "S" && exibirFiltroEstoqueDisponivelOutrasFiliais
    ,
    mascara: mascara,
    onPesquisaClasse: onPesquisaClasse,
    onExcluirClasse: onExcluirClasse,
    onPesquisaFornecedor: onPesquisaFornecedor,
    onExcluirFornecedor: onExcluirFornecedor,
    onCodigoModificado: onCodigoModificado,
    onReferenciaModificado: onReferenciaModificado,
    onDescricaoModificado: onDescricaoModificado,
    onClasseModificado: onClasseModificado,
    onFornecedorModificado: () => { },
    onEstoqueDisponivelFilialCorrente: onEstoqueDisponivelFilialCorrente,
    onEstoqueDisponivelOutrasFiliais: onEstoqueDisponivelOutrasFiliais,
    onEstoqueDisponivelCD: onEstoqueDisponivelCD, // 435588
    onOrdemModificado: onOrdemModificado,
    opcoesDisponibilidade: listaDisponibilidade,
    opcoesSistemaTintometrico: listaSistemaTintometrico,
    utilizaSistemaTintometrico:
      valorParametro("UTILIZA_SISTEMA_TINTOMETRICO") === "S"
    ,
    produtoEmTransito: valorParametro("PRODUTO_EM_TRANSITO") === "S",
    maisFiltrosDados: filtros as MaisFiltrosDados,
    pesquisaProduto: filtros as DadosPesquisaProduto,
    onCodigoFabricanteModificado: onCodigoFabricanteModificado,
    onCodigoSistemaTintometricoModificado: onCodigoSistemaTintometricoModificado,
    onTextoTecnicoModificada: onTextoTecnicoModificada,
    onModeloModificado: onModeloModificado,
    onDisponibilidadesModificadas: onDisponibilidadesModificadas,
    onProdutoEmTransitoModificado: onProdutoEmTransitoModificado,
    onApenasProdutoFinalModificado: onApenasProdutoFinalModificado,
    onApenasFabricacaoPropriaModificado: onApenasFabricacaoPropriaModificado,
    onProdutoOfertaModificado: onProdutoOfertaModificado,
    onConsiderarEstoqueDisponivelLote: onConsiderarEstoqueDisponivelLote, //435588
    onTipoFiltroEstoqueModificado: onTipoFiltroEstoqueModificado, //435588
    onQuantidadeInicialFiltroEstoqueModificado: onQuantidadeInicialFiltroEstoqueModificado, // 435588
    onQuantidadeFinalFiltroEstoqueModificado: onQuantidadeFinalFiltroEstoqueModificado, // 435588
    onMarkupInicialModificado: onMarkupInicialModificado,
    onMarkupFinalModificado: onMarkupFinalModificado,
    onToggleColunaSelecionada: toggleColunaSelecionada,
    colunas: colunas,
    itens: dadosPesquisaItens?.Entities,
    onAlterarFonte: onAlterarFonte,
    produtosAgregadoExpandido: produtosAgregadoExpandido,
    produtosAgregadoSugeridoExpandido: produtosAgregadoSugeridoExpandido,
    iconeProdutoAgregadoSugeridoExpandido: iconeProdutoAgregadoSugeridoExpandido,
    iconeProdutoAgregadoExpandido: iconeProdutoAgregadoExpandido,
    tamanhoFontePadrao: tamanhoFonte,
    corSelecionado: usuarioLogado?.CorFundo,
    textoSelecionado: usuarioLogado?.CorTexto,
    onMostrarInformacoesProduto: onMostrarInformacoesProduto,
    onMostrarTinta: onMostrarTinta,
    onProdutosSelecionados: onSelecionarProdutos,
    mascaraClasse: mascara,
    exibirTextoTecnico: exibirTextoTecnico,
    exibirColunaMarkup:
      valorParametro("VISUALIZA_MARKUP_PRODUTO_ORCAMENTO") == "S"
    ,
    exibirEstoqueOutrasFiliais:
      valorParametro("EXIBIR_ESTOQUE_OUTRAS_FILIAIS") === "S"
    ,
    exibirEstoqueTotal:
      valorParametro("EXIBIR_COLUNA_ESTOQUE_TOTAL_PRODUTO_VENDAS") === "S"
    ,
    exibirColunaEstoqueTotalProdutoVendas:
      valorParametro("EXIBIR_COLUNA_ESTOQUE_TOTAL_PRODUTO_VENDAS") === "S"
    ,
    utilizaDescontoMaximoBonificacaoAvancados:
      valorParametro(
        "ORCWEB_UTILIZA_DESCONTO_MAXIMO_BONIFICACAO_AVANCADOS"
      ) === "S"
    ,
    exibirPrecoAVista:
      valorParametro("EXIBIR_PRECO_COMISSAO_NA_CONSULTA_PRODUTOS") === "S"
    ,
    numeroCasasDecimaisQuantidade: globalMU.resolverNumeroCasasDecimaisDeParametroFormatado(valorParametro("ORCAMENTO_MASCARA_QUANTIDADE"), 3),
    onPesquisarPaginaPesquisaProduto: onPesquisar,
    desativarBotaoComparar: itensSelecionados.length < 2,
    desativarBotaoAcoes: desativarBotaoAcoes,
    onComparar: onComparar,
    numeroTotalPaginas: dadosPesquisaItens?.PageCount,
    numeroPagina: dadosPesquisaItens?.ActualPage,
    onAlterarListaSelecionada: pesquisaPaginada,
    onToggleSelecionarTodasColunas: toggleSelecionarTodasColunas,
    obterPermiteEngrenagemGrid: permiteEngrenagemGrid,
    onSelecionarTodos: onSelecionarTodos,
    produtosSelecionados: itensSelecionados,
    onOk: onOk,
    onInserirContinuar: onInserirContinuar,
    onInserirNovo: onInserirNovo,
    onIncrementarQuantidade: onIncrementarQuantidade,
    onProdutoRepetido: onProdutoRepetido,
    onPesquisaProdutoAgregado: onPesquisarProdutoComAgregado,
    onProdutoAgregadoExpandido: onPesquisarProdutoAgregadoSugerido,
    onAlteracaoQuantidade: onAlteracaoQuantidade,
    onMostrarImagens: onMostrarImagens,
    tintasConfiguradas: tintasConfiguradas,
  }), [
    chaveMovimentacaoEhReferencia,
    props.desabilitarPesquisarHistorico,
    processandoProduto,
    props.chamadoParaInserirProdutoNoOrcamento,
    modalCestaProdutosAberto,
    onFecharModalCestaProdutos,
    props.pesquisandoApenasParaFiltroProdutosLupa,
    props.ocultarSubPaginas,
    orcamento.SomenteLeitura,
    props.foraOrcamento,
    valorParametro,
    filtrouAlgumCheckboxEstoquesDisponivel,
    onToggleProdutoSelecionado,
    onPesquisaPreVenda,
    onPesquisasAnteriores,
    onPesquisarCores,
    exibirFiltroEstoqueDisponivel,
    exibirFiltroEstoqueDisponivelOutrasFiliais,
    mascara,
    onPesquisaClasse,
    onExcluirClasse,
    onPesquisaFornecedor,
    onExcluirFornecedor,
    onCodigoModificado,
    onReferenciaModificado,
    onDescricaoModificado,
    onClasseModificado,
    onEstoqueDisponivelFilialCorrente,
    onEstoqueDisponivelOutrasFiliais,
    onEstoqueDisponivelCD,
    onOrdemModificado,
    listaDisponibilidade,
    listaSistemaTintometrico,
    filtros,
    onCodigoFabricanteModificado,
    onCodigoSistemaTintometricoModificado,
    onTextoTecnicoModificada,
    onModeloModificado,
    onDisponibilidadesModificadas,
    onProdutoEmTransitoModificado,
    onApenasProdutoFinalModificado,
    onApenasFabricacaoPropriaModificado,
    onProdutoOfertaModificado,
    onConsiderarEstoqueDisponivelLote,
    onTipoFiltroEstoqueModificado,
    onQuantidadeInicialFiltroEstoqueModificado,
    onQuantidadeFinalFiltroEstoqueModificado,
    onMarkupInicialModificado,
    onMarkupFinalModificado,
    colunas,
    dadosPesquisaItens,
    onAlterarFonte,
    produtosAgregadoExpandido,
    produtosAgregadoSugeridoExpandido,
    iconeProdutoAgregadoSugeridoExpandido,
    iconeProdutoAgregadoExpandido,
    tamanhoFonte,
    usuarioLogado,
    onMostrarInformacoesProduto,
    onMostrarTinta,
    onSelecionarProdutos,
    exibirTextoTecnico,
    onPesquisar,
    itensSelecionados,
    desativarBotaoAcoes,
    onComparar,
    pesquisaPaginada,
    permiteEngrenagemGrid,
    onSelecionarTodos,
    onOk,
    onInserirContinuar,
    onInserirNovo,
    onIncrementarQuantidade,
    onProdutoRepetido,
    onPesquisarProdutoComAgregado,
    onPesquisarProdutoAgregadoSugerido,
    onAlteracaoQuantidade,
    onMostrarImagens,
    tintasConfiguradas,
  ])

  const produtosSelecionadosContextValue = useMemo<ProdutosSelecionadosContextType>(() => ({
    desativarBotaoSelecionar: (itensSelecionados?.length ?? 0) === 0,
    desativarBotaoAplicarItens: (produtosSelecionados?.length ?? 0) === 0,
    quantidadeItensSelecionados: itensSelecionados?.length ?? 0,
    onSelecionar: onAdicionarProdutosSelecionados,
    onAplicarItens: onAplicarItens,
    produtosSelecionados: produtosSelecionados,
    onRemoverProduto: onRemoverProdutoSelecionado,
    onRemoverTodasDuplicatasProduto: onRemoverTodasDuplicatasProdutoSelecionado,
    onAlterarQuantidade: onAlterarQuantidadeProdutoSelecionado,
    onAlterarAcaoProdutoRepetido: onAlterarAcaoProdutoRepetidoSelecionado,
    onMostrarInformacoesProduto: onMostrarInformacoesProduto,
    onAdicionarProdutoSelecionado: onAdicionarProdutoSelecionado,
    onInserirProdutoDuplicadoSelecionado: onInserirProdutoDuplicadoSelecionado,
    onLimparProdutosSelecionados: onLimparProdutosSelecionados,
    processandoProduto: processandoProduto,
    produtoJaExisteNoOrcamento: produtoJaExisteNoOrcamento,
  }), [
    itensSelecionados,
    produtosSelecionados,
    onAdicionarProdutosSelecionados,
    onAplicarItens,
    onRemoverProdutoSelecionado,
    onRemoverTodasDuplicatasProdutoSelecionado,
    onAlterarQuantidadeProdutoSelecionado,
    onAlterarAcaoProdutoRepetidoSelecionado,
    onMostrarInformacoesProduto,
    onAdicionarProdutoSelecionado,
    onInserirProdutoDuplicadoSelecionado,
    onLimparProdutosSelecionados,
    processandoProduto,
    produtoJaExisteNoOrcamento,
  ])

  return (
    <ProdutosSelecionadosContext.Provider value={produtosSelecionadosContextValue}>
      {!parametrosCarregados ? <>Carregando... Aguarde!</> :
        <Breadcrumb2Container
          passos={passosInterno.current.keysToList()}
          exibirBotaoLimpar={false}
          id="PaginaPesquisaProdutoContainer"
          key="PaginaPesquisaProdutoContainer_passosInterno"
          exibirBotaoVoltar={!props.foraOrcamento}
          onPassoSelecionado={onPassoSelecionado}
          onBotaoVoltarClicado={onVoltar}
        />
      }

      {!parametrosCarregados ? <></> :
        <PaginaPesquisaProdutoContext.Provider
          key="PaginaPesquisaProdutoContainer_PaginaPesquisaProduto"
          value={paginaPesquisaProdutoContextValue}>
          <PaginaPesquisaProduto
            chamadoPeloTrocarProduto={props.chamadoPeloTrocarProduto} // 470882
            ocultarBarraPesquisa={props.ocultarBarraPesquisa}
            permiteProdutoForaEstoque={valorParametro("PROD_SEM_EST") == "S"}
            mostrarBotaoPesquisarInserirContinuar={orcamento.TipoOrcamento >= 0}
            mostrarBotaoProdutosForaDeEstoque={(orcamento.TipoOrcamento == null || orcamento.TipoOrcamento <= 0) && exibirBotaoProdutosForaDoEstqoue && !props.esconderForaEstoque}
            onPesquisarInserirContinuar={onPesquisarInserirContinuar}
            onPesquisarProdutosForaEstoque={onPesquisarProdutosForaEstoque}
            exibirBarraGrid={permiteIncluirOrcamento}
            myRef={myRef}
          />
        </PaginaPesquisaProdutoContext.Provider>
      }
    </ProdutosSelecionadosContext.Provider>
  );
};
